import {
  CModal,
  CModalBody,
  CModalFooter,
  CFormLabel,
  CFormInput,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CModalHeader,
  CModalTitle,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CFormTextarea,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CTable,
  CCard,
  CCardBody,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CTooltip,
  CProgress,
  CProgressBar,
  CAvatar,
} from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import PatientInfo from './PatientInfo.jsx'
import './Patient.css'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Select from 'react-select'
import AddPatientForm from './AddNewPatient'
import SavePatients from '../../services/general/savePatientinformation.api'
import InsuranceTab from './InsuaranceTab.jsx'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api.js'
import EditIcon from '@material-ui/icons/Edit'
import VisibilityIcon from '@material-ui/icons/Visibility'
import DeleteIcon from '@material-ui/icons/Delete'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import Pageloader from '../../components/shared/Pageloader.jsx'
import PatientPopup from './PatientPopup.jsx'
import SaveExtra from '../../services/general/saveExtraData.api.js'
import { motion } from 'framer-motion'
import { AlignLeft, CalendarCheck, Download, EllipsisVertical, FilePenLine, RefreshCcw, Table2, TrainFrontTunnel, X } from 'lucide-react'
import { FunnelPlotOutlined } from '@ant-design/icons'
import PatientNoteDataCRUD from '../../../src/services/general/patientNoteData.api.js'
import toast from 'react-hot-toast'
import { toastConfig } from '../../../src/constants/other.config.js'
import { HiExclamationCircle, HiEye, HiPencil } from 'react-icons/hi'
import { DoneAllSharp, Schedule } from '@mui/icons-material'
import PatientSuperBillData from '../../services/general/patientSuperBill.api.js'
import PatientProviderPatientInfo from './PatientProviderPatientInfo.jsx'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
import PatientAppointmentDetails from '../../services/general/appointmentData.api.js'
import { useSidebar } from '../../components/SidebarContext.jsx'
import PatientInfoTodaysAppointments from './PatientInfoTodaysAppointments.jsx'
import { useIndexedDB } from '../../context/IndexedContext.jsx'

import PatientImagingsCRUD from '../../services/general/patientImagingData.js'
import PatientMedications from '../../services/general/patientMedicationData.api'
import PatientOrdersCRUD from '../../services/general/patientOrders.api.js'
import GetQuestionBank from '../../services/general/saveQuestionBank.api'
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api.js'
import InternalNotesCRUD from '../../services/general/internalNotesAPI.api.js'
import ModifyPatientHistory from '../../services/general/modifyPatientHistory.api.js'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api.js'
import GetPatientAllergiesCRUD from '../../services/general/getPatientAllergies.api.js'
import PatientLabsCRUD from '../../services/general/patientLabsCrud.api.js'
import logo from '../../assets/images/avatars/logo3.png'
import UploadPatient from './UploadPatient.jsx'
import PatientPhysicalExaminationData from '../../services/general/physicalExaminationData.api.js'
import PatientReportCRUD from '../../services/general/patientReportCrud.api.js'
import UploadOpenChartPatient from './UploadOpenChartPatient.jsx'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api.js'
import { getAllAppointmentsDetails } from '../../components/shared/appointmentFilterData.jsx'
import { getFacilityParentCompany, getPatientFacilityParentCompany } from '../../utils/facilityParentCompany'
import { patientMatchesSearch } from '../../utils/searchUtils'

const PatientProviderAppointment = () => {
  const [patientIDClicked, setPatientIDClicked] = useState(-1)
  const [rowClicked, setRowClicked] = useState(null)
  const [selectedFacility, setSelectedFacility] = useState({})
  const [roomNumber, setRoomNumber] = useState('')
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [addedInsurances, setAddedInsurances] = useState([])
  const [insuranceList, setInsuranceList] = useState([])
  const [selectedDetails, setSelectedDetails] = useState({})
  const [activeTab, setActiveTab] = useState('patientDetails')
  const buttonList = [{ Name: 'View' }, { Name: 'Edit' }, { Name: 'Delete' }]
  const [patientID, setPatientID] = useState('')
  const [diagnosisData, setDiagnosisData] = useState([])
  var selectedDiagnosis = []
  const [allSelectedDiagnosis, setAllSelectedDiagnosis] = useState([])
  const [facilities, setFacilities] = useState([])
  const [patientData, setPatientData] = useState('')
  const [patientCount, setPatientCount] = useState(-1)
  const [viewPatientDetail, setViewPatientDetail] = useState()
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [patientModelVisible, setPatientModalVisible] = useState(false)
  const [dataCallType, setDataCallType] = useState(null)
  const [setDataId, setEditDataId] = useState(null)
  const [showPatientInfo, setShowPatientInfo] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deletePatientID, setDeletePatientID] = useState(null)
  const [appointment, setAppointment] = useState([])
  const [appointmentPatient, setAppointmentPatient] = useState(null)
  const [appointments, setAppointments] = useState([])
  const [noteID, setNoteID] = useState(null)
  const [cancelModel, setCancelModel] = useState(false)
  const [finishModel, setFinishModel] = useState(false)
  const [appointmentDataID, setAppointmentDataID] = useState(null)
  const [appointmentID, setAppointmentID] = useState(null)
  const [allAppointment, setAllAppointment] = useState([])
  const [noteStatus, setNoteStatus] = useState('New Note')
  const [patientAppointmentID, setPatientAppointmentID] = useState(null)
  const [patientId, setPatientId] = useState(null)
  const [creatingNewNote, setCreatingNewNote] = useState(false)
  const [superBill, setSuperBill] = useState([])
  const [scheduleTime, setScheduleTime] = useState(null)
  const [deleteModel, setDeleteModel] = useState(false)
  const [loggedUserProvider, setLoggedUserProvider] = useState({})
  const [allAppointmentRawData, setAllAppointmentRawData] = useState([])
  const [isRefreshLoad, setIsRefreshLoad] = useState(false)
  const [isRrefreshedToday, setIsRefreshedToday] = useState(() => {
    const stored = localStorage.getItem('isRefreshedToday')
    if (!stored) return false

    return new Date(stored).toDateString() === new Date().toDateString()
  })
  const [hpiAdded, setHpiAdded] = useState(false)
  const [patientInfoCount, setPatientInfoCount] = useState({
    followUp: 0,
    newPatient: 0,
  })
  const { isSidebarOpen, toggleSidebar, closeSidebar, openSidebar } = useSidebar()
  const [boxView, setBoxView] = useState('list')
  const [refreshCounter, setRefreshCounter] = useState(0)
  const [childformData, setChildFormData] = useState({
    FirstName: '',
    MiddleName: '',
    LastName: '',
    DOB: '',
    Gender: '',
    Age: '0',
    PhoneNumber: '',
    EmergencyName: '',
    EmergencyPhone: '',
    Address: '',
    State: '',
    City: '',
    ZipCode: '',
    Country: '',
    insurance: '',
  })

  const resetStates = () => {
    setChildFormData({
      FirstName: '',
      MiddleName: '',
      LastName: '',
      DOB: '',
      Gender: '',
      Age: '0',
      PhoneNumber: '',
      EmergencyName: '',
      EmergencyPhone: '',
      Address: '',
      State: '',
      City: '',
      ZipCode: '',
      Country: '',
      insurance: '',
    })
    setRoomNumber('')
    setSelectedFacility({})
    setAddedInsurances([])
    setInsuranceList([])
    setSelectedDetails({})
    setAllSelectedDiagnosis([])
    setModalVisible(false)
  }

  const { getImagingDetailsAllMaster, checkIfMastersExist, saveOfflineData, getMedicationMasterData, getProviderDetails, getOfflineData, saveOpenChartOfflineData, getOpenChartOfflineData, getOpenChartAppointmentData, saveOpenChartAppointmentData, saveAllAppointmentData, saveAllAppointmentDetails, getPreSignedData, getPreSignedAppointment } =
    useIndexedDB()

  useEffect(() => {
    // if sidebar is not showing on page render then show
    if (!isSidebarOpen) {
      openSidebar()
    }
  }, [])

  const [daysMap, setDaysMap] = useState({})
  const [locations, setLocations] = useState([])
  const [cancelReason, setCancelReason] = useState('')

  const patientSelected = async (rowSelected) => {
    getData()
    setViewPatientDetail(rowSelected)

    let patientInsurance = await PatientInsuranceFn('SELECTALL', '', rowSelected.PatientID)

    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
    } catch (e) {}

    try {
      let tempSelectedDiagnosis = rowSelected.Diagnosis ? rowSelected.Diagnosis.split(',') : []
      selectedDiagnosis = diagnosisData.filter((obj) => tempSelectedDiagnosis.includes(obj.label))
      setRoomNumber(rowSelected?.Room)
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      setSelectedFacility(userFacilities ? userFacilities : facilities[0])
      setAllSelectedDiagnosis(selectedDiagnosis)
    } catch (e) {
      setAllSelectedDiagnosis([])
    }

    setChildFormData({
      FirstName: rowSelected.FirstName || '',
      MiddleName: rowSelected.MiddleName || '',
      LastName: rowSelected.LastName || '',
      DOB: rowSelected.DOB || '',
      Gender: rowSelected.Gender || '',
      Age: rowSelected.Age || '0',
      PhoneNumber: rowSelected.PhoneNumber || '',
      EmergencyName: rowSelected.EmergencyName || '',
      EmergencyPhone: rowSelected.EmergencyPhone || '',
      Address: rowSelected.Address || '',
      State: rowSelected.State || '',
      City: rowSelected.City || '',
      ZipCode: rowSelected.ZipCode || '',
      Country: rowSelected.Country || '',
    })

    setSelectedDetails({ Insurances: patientInsurance })
  }

  const openTreatmentNote = (rowSelected, appointmentID) => {
    setPatientID(rowSelected?.PatientID)
    setPatientIDClicked(rowSelected?.PatientID)
    setRowClicked(rowSelected)
    setPatientModalVisible(true)
    setPatientAppointmentID(appointmentID)
  }
  // const getAppointmentData = async () => {

  //     try {

  //         let data = await SaveExtra('Get_By_Type', 'AppointmentsData', '', '')
  //         data = JSON.parse(data.d)?.Data || [];

  //         if (data) {
  //             data = data?.map((item) => {
  //                 return {
  //                     Id: item.Id,
  //                     Data: JSON.parse(item?.JsonData)
  //                 }
  //             })

  //         }
  //         setAppointmentDataID(data)
  //         setAppointments(data[0]?.Data)
  //         return data[0]?.Data || []
  //     } catch (error) {
  //         console.log(error)
  //     } finally {
  // setIsPageLoading(false);

  //     }
  // };

  const isManuallyScheduledAppointment = (appointment) => {
    const status = appointment?.data?.Status
    const scheduleBy = appointment?.data?.ScheduleBy
    const type = appointment?.data?.Type
    const isInFacility = appointment?.data?.isInFacility
    const priorAuth = appointment?.data?.otherDetails?.priorAuth?.isRequired

    let priorAuthTime = 0
    if (priorAuth) {
      priorAuthTime = parseInt(appointment?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
    }

    const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
    const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

    return isScheduledOrRescheduled && isManualOrFollowUp
  }

  const getAppointmentData = async () => {
    // setIsPageLoading(true)
    try {
      //   const result = await PatientAppointmentDetails("GET", '', "", '', '')
      const result = await PatientAppointmentDetails('GETBYPROVIDERID', '', '', loggedUserProvider?.ID, '')

      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '');
      const rawData = JSON.parse(result.d)?.Data || []

      setAllAppointmentRawData(
        rawData.map((item) => {
          return {
            ...item,
            AppointmentDetails: JSON.parse(item?.AppointmentDetails),
          }
        }),
      )

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      setAllAppointment(structuredData)

      let flatAppointments = structuredData.flatMap((p) => p.appointmentDetails)
      const AppointmentCount = flatAppointments.filter((item) => isManuallyScheduledAppointment(item))
      // setPatientCount(AppointmentCount.length)
      setAppointments(flatAppointments)

      return flatAppointments
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      // setIsPageLoading(false)
    }
  }
  const getAppointmentData2 = async (isRefresh = true) => {
    try {
      let flatAppointments = []

      if (!isRefresh) {
        const cachedData = localStorage.getItem('appointmentsData')
        if (cachedData) {
          const parsedData = JSON.parse(cachedData)
          setAllAppointment(parsedData.allAppointment || [])
          setAllAppointmentRawData(parsedData.allAppointmentRawData || [])
          flatAppointments = parsedData.flatAppointments || []
          setAppointments(flatAppointments)
          // setPatientCount(parsedData.patientCount || 0)
          return flatAppointments
        } else {
          return []
        }
      }

      const result = await PatientAppointmentDetails('GETBYPROVIDERID', '', '', loggedUserProvider?.ID, '')
      const rawData = JSON.parse(result.d)?.Data || []

      const allAppointmentRawData = rawData.map((item) => ({
        ...item,
        AppointmentDetails: JSON.parse(item?.AppointmentDetails),
      }))
      setAllAppointmentRawData(allAppointmentRawData)

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      setAllAppointment(structuredData)

      flatAppointments = structuredData.flatMap((p) => p.appointmentDetails)

      const AppointmentCount = flatAppointments.filter((item) => isManuallyScheduledAppointment(item))

      // setPatientCount(AppointmentCount.length)
      setAppointments(flatAppointments)

      // Store in localStorage
      localStorage.setItem(
        'appointmentsData',
        JSON.stringify({
          allAppointment: structuredData,
          allAppointmentRawData,
          flatAppointments,
          patientCount: AppointmentCount.length,
        }),
      )

      return flatAppointments
    } catch (error) {
      console.error('Error in getAppointmentData', error)
    }
  }

  const getAppointmentForAutoSchedule = async () => {
    // setIsPageLoading(true)
    try {
      const result = await PatientAppointmentDetails('GET', '', '', '', '')

      // const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '');
      const rawData = JSON.parse(result.d)?.Data || []

      let structuredData = []

      rawData.forEach((item) => {
        let parsedList = JSON.parse(item?.AppointmentDetails)

        if (Array.isArray(parsedList)) {
          parsedList.forEach((parsedItem) => {
            const patientID = parsedItem?.patientID
            const appointmentDetails = parsedItem?.appointmentDetails || []

            const formattedAppointments = appointmentDetails.map((appointment) => {
              const data = appointment?.data || {}
              const current = appointment?.current || {
                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                Facility: { value: '', label: data?.Facility || 'Unknown' },
                Insurance: data?.Insurance || {},
                otherDetails: data?.otherDetails || {},
              }

              return { data, current }
            })

            structuredData.push({
              patientID,
              appointmentDetails: formattedAppointments,
            })
          })
        } else {
          console.warn('Unexpected non-array parsed data:', parsedList)
        }
      })

      return structuredData
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  const patientDataFn = async () => {
    // setIsPageLoading(true)
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      let patient = JSON.parse(patientData.d).Data
      let appointments = await getAppointmentData()
      let schedulePatient = patient?.filter((patient, index) => appointments.find((item) => item.current.Patient.value === patient.PatientID))

      setPatientData(schedulePatient)
      setAppointment(appointments)

      let count = schedulePatient.length
      // setPatientCount(count)
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }
  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)

    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data

    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))
    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
  }

  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      const formattedData = data.map((facility) => ({
        value: facility.ID,
        label: facility.Name,
        parentCompany: getFacilityParentCompany(facility),
      }))
      setFacilities(formattedData)
      setSelectedFacility(formattedData[0])
    } catch (e) {}
  }

  const [modalVisible, setModalVisible] = useState(false)
  const [viewModalVisible, setViewModalVisible] = useState(false)

  const handleonClick = () => {
    setModalVisible((e) => !e)
  }

  const patientSelectedFacility = async (rowSelected) => {
    try {
      const userFacilities = facilities.find((item) => item.label === rowSelected?.FacilityName)
      // setSelectedFacility(userFacilities ? userFacilities : facilities[0]);
      return userFacilities ? userFacilities : facilities[0]
    } catch (e) {}
  }

  const saveDiagnosisData = async (customData) => {
    let a = {}
    let facility = await patientSelectedFacility(customData)
    try {
      a['FacilityID'] = facility?.value.toString() || selectedFacility?.value.toString()
      a['FacilityName'] = facility?.label.toString() || selectedFacility?.label.toString()
      a['Room'] = customData?.Room?.toString() || roomNumber.toString()
    } catch (e) {
      a['FacilityID'] = ''
      a['FacilityName'] = ''
      a['Room'] = -1
    }

    // let allDiagnosis = allSelectedDiagnosis.map(obj => { return obj.label }).join(",");

    let allDiagnosis = customData?.Diagnosis || ''

    let insurances = addedInsurances.map((ins) => ({
      InsuranceID: ins?.ID,
    }))

    let savePatientInfo
    if (patientID && patientID !== '') {
      savePatientInfo = SavePatients('Update', JSON.stringify(customData ? customData : childformData), JSON.stringify(a), allDiagnosis, patientID, JSON.stringify(insurances))
    }

    // await savePatientInfo;

    await patientDataFn()
    // resetStates()
  }

  useEffect(() => {
    getAppointmentData()
    getData()
    patientDataFn()
    getFacilities()
  }, [loggedUserProvider])

  const noteStructureRef = useRef({})

  // if (rowClicked) {
  //   let provideInformation = rowClicked.Diagnosis.split(',');
  //   let information = provideInformation.map((item) => {
  //     return (
  //       { diagnosis: item, information: 'patient' }
  //     )
  //   })

  //   noteStructureRef.current = {
  //     ...noteStructureRef.current,
  //     information,
  //   }

  // }

  const handleDeletePatient = async () => {
    let patientData = await SavePatients('Delete', '', '', '', deletePatientID, '')
    await patientDataFn()
    setDeletePatientID(null)
    setDeleteVisible(false)
  }

  const handleClicksPatiens = (patient) => {
    setPatientIDClicked(patient?.PatientID)
    setPatientID(patient?.PatientID)
    setRowClicked(patient)
    setShowPatientInfo(true)
  }
  const [showFilter, setShowFilter] = useState(false)
  const [filterData, setFilterData] = useState({
    facility: [],
    searchValue: '',
    scheduleDate: '',
    date: '',
    status: [],
  })
  const [filteredPatientData, setFilteredPatientData] = useState([])

  const selectStatusOption = [
    { value: 'NewPatient', label: 'New Patient' },
    { value: 'Follow Up', label: 'Follow Up' },
    { value: 'Re Admit', label: 'Re Admit' },
  ]

  const selectedOption = selectStatusOption.find((option) => option.value === filterData.status)

  const getProvidersMaster = async () => {
    // setIsPageLoading(true)
    try {
      // Fetch provider data
      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      const getUser = JSON.parse(localStorage.getItem('user'))
      const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      setLoggedUserProvider(foundProvider || {})
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getProvidersMaster()
  }, [])

  // const GetPatientTreatmentsNotes = async () => {
  //   if (!patientData) return

  //   try {
  //     let updatedPatients = await Promise.all(
  //       patientData.map(async (patient) => {
  //         let status = patient.noteStatus || 'Not Created' // Default status
  //         let flag = 'false' // Default flag

  //         try {
  //           const dataResponse = await PatientNoteDataCRUD('GET', patient?.PatientID)
  //           const parsedData = JSON.parse(dataResponse?.d)?.Data

  //           if (Array.isArray(parsedData) && parsedData.length > 0) {
  //             status = parsedData[parsedData.length - 1]?.status || status
  //             flag = parsedData[parsedData.length - 1]?.flag || 'false'
  //           }
  //         } catch (err) {
  //           console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
  //         }

  //         const patientAppointments = appointment.filter((item) => item.current.Patient.value === patient.PatientID)

  //         // let providerName = provider[0]?.current?.Provider?.label;
  //         // let scheduleDate = provider[0]?.data?.StartTime
  //         // scheduleDate = scheduleDate?.split(" ")

  //         const scheduledAppointment = patientAppointments.find((p) => {
  //           const status = p?.data?.Status
  //           const scheduleBy = p?.data?.ScheduleBy
  //           const type = p?.data?.Type
  //           const isInFacility = p?.data?.isInFacility
  //           const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
  //           const noteSeen = p?.data?.patientSeen
  //           let priorAuthTime = 0
  //           if (priorAuth) {
  //             priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
  //           }

  //           // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
  //           const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
  //           const isScheduledOrRescheduled = (status === 'Scheduled' && noteSeen !== false) || (status === 'Rescheduled' && noteSeen !== false)

  //           return isScheduledOrRescheduled && isManualOrFollowUp
  //         })

  //         if (!scheduledAppointment) return null

  //         const providerName = scheduledAppointment?.current?.Provider?.label
  //         const scheduleDate = scheduledAppointment?.data?.StartTime?.split(' ')[0]
  //         const Type = scheduledAppointment?.data?.Type

  //         const isProviderAppointment = providerName === loggedUserProvider?.Name

  //         if (!isProviderAppointment) return null

  //         return {
  //           ...patient,
  //           noteStatus: status,
  //           noteFlag: flag,
  //           appointmentScheduleDate: scheduleDate,
  //           patientTerm: scheduledAppointment?.data?.term || '',
  //           ...(typeof scheduledAppointment?.data?.patientSeen === 'boolean' && {
  //             patientSeen: scheduledAppointment.data.patientSeen,
  //             notSeenReason: scheduledAppointment.data.notSeenReason,
  //           }),
  //         }
  //       }),
  //     )
  //     // updatedPatients = updatedPatients.filter(item => item.noteStatus === "Submitted")
  //     updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag == 'true' && item?.noteStatus == 'Draft'))

  //     setFilteredPatientData(updatedPatients)
  //   } catch (error) {
  //     console.error('Error fetching patient orders', error)
  //     // toast.error('Error in patient treatment', toastConfig);
  //   }
  // }

  const extractUniqueKeywords = (keywordsArray) => {
    let parsedArray = []

    try {
      parsedArray = typeof keywordsArray === 'string' ? JSON.parse(keywordsArray) : keywordsArray
    } catch (err) {
      console.error('Error parsing keywords:', err)
      parsedArray = []
    }

    if (!Array.isArray(parsedArray)) parsedArray = []

    const allKeywords = parsedArray.flatMap((item) => (item.keyword ? item.keyword.split(',') : [])).map((keyword) => keyword.trim())

    const uniqueKeywords = Array.from(new Set(allKeywords))

    return uniqueKeywords
  }

  const getPatientInternalNotes = async (patientID) => {
    let allData = await InternalNotesCRUD('GET', patientID)
    let history = JSON.parse(allData?.d)
    let sortedNotes = history?.Data?.sort((a, b) => new Date(b.Id) - new Date(a.Id))
    return sortedNotes
  }

  const getHospitalRecord = async (patientID) => {
    let allData = await ModifyPatientHistory('GET', patientID)
    const history = JSON.parse(allData?.d)

    return history
  }

  const historyObjectKeysParticular = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const getDataPersonalHistoryInNote = async (patientID) => {
    let history = {}

    for (const [key, value] of Object.entries(historyObjectKeysParticular)) {
      let allData = await getPatientPersonalHistory('GET', patientID, value, '')

      const formattedData = JSON.parse(allData?.d)

      history[key] = formattedData?.Data
    }
    return history
  }

  const getPatientAllergy = async (patientID) => {
    let formattedData = await GetPatientAllergiesCRUD('GET', patientID)
    formattedData = JSON.parse(formattedData.d)
    formattedData = formattedData?.Data || []

    return formattedData
  }

  const getPatientVitals = async (patientID) => {
    let allVital = { PatientID: patientID }
    allVital = [allVital]
    let allData
    allData = await fetchPatientData('GET', 'Vitals', JSON.stringify(allVital))

    allData = JSON.parse(allData.d) || {}

    return allData?.Data
  }

  const fetchPatientLabs = async (patientID) => {
    try {
      let formattedData
      formattedData = await PatientLabsCRUD('GET', patientID.toString())
      formattedData = JSON.parse(formattedData.d)
      formattedData = formattedData?.Data || []
      if (formattedData) {
        formattedData = formattedData?.map((item) => {
          return {
            ...item,
            data: JSON.parse(item.data),
          }
        })
      }

      formattedData.sort((a, b) => b.id - a.id)

      return formattedData
    } catch (error) {
      console.log(error)
    }
  }

  const getPatientPhysicalExamination = async (patientID) => {
    let response = await PatientPhysicalExaminationData('Get_By_Patient', patientID)
    const parsedData = JSON.parse(response.d).Data || []

    return parsedData
  }

  const getPatientSuperBill = async (PatientID) => {
    let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', PatientID)
    data = JSON.parse(data?.d)?.Data || []
    return data ?? []
  }

  const [appointmentProgress, setAppointmentProgress] = useState(0)

  const GetAppointmentsAllDataInDb = async (updatedPatients) => {
    if (!Array.isArray(updatedPatients)) return

    const totalCalls = 2 + updatedPatients.length * 16 + 3
    const progressStep = 100 / totalCalls

    const incrementProgress = () => {
      setAppointmentProgress((p) => Math.min(p + progressStep, 100))
    }

    // await patientDataFn()
    // setIsRefreshLoad(true)
    try {
      // let updatedPatients = await Promise.all(
      //   appointment.map(async (appt) => {
      //     const patient = patientData.find((p) => p.PatientID === appt?.data?.PatientID)
      //     if (!patient) return null

      //     let status = patient.noteStatus || 'Not Created'
      //     let flag = 'false'
      //     if (!appt?.data?.NoteID) return null

      //     let parsedData = []
      //     try {
      //       const dataResponse = await PatientNoteDataCRUD('GET', patient.PatientID)
      //       parsedData = JSON.parse(dataResponse?.d)?.Data || []
      //       if (parsedData.length > 0) {
      //         const lastNote = parsedData[parsedData.length - 1]
      //         status = lastNote?.status || status
      //         flag = lastNote?.flag || 'false'
      //       }
      //     } catch (err) {
      //       console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
      //     }

      //     const scheduleStatus = appt?.data?.Status
      //     const scheduleBy = appt?.data?.ScheduleBy
      //     const type = appt?.data?.Type
      //     const isInFacility = appt?.data?.isInFacility
      //     const priorAuth = appt?.data?.otherDetails?.priorAuth?.isRequired
      //     const noteSeen = appt?.data?.patientSeen
      //     let priorAuthTime = priorAuth ? parseInt(appt?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10) : 0

      //     const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
      //     const isScheduledOrRescheduled = (scheduleStatus === 'Scheduled' && noteSeen !== false) || (scheduleStatus === 'Rescheduled' && noteSeen !== false)
      //     if (!(isScheduledOrRescheduled && isManualOrFollowUp)) return null

      //     const providerName = appt?.current?.Provider?.label
      //     const scheduleDate = appt?.data?.StartTime?.split(' ')[0]
      //     const isProviderAppointment = providerName === loggedUserProvider?.Name
      //     if (!isProviderAppointment) return null

      //     return {
      //       ...patient,
      //       patientData: patient,
      //       noteStatus: status,
      //       noteFlag: flag,
      //       appointmentData: appt?.data,
      //       allNotes: parsedData,
      //       appointmentScheduleDate: scheduleDate,
      //       appointmentID: appt?.data?.AppointmentID,
      //       AddedByApp: appt?.data?.AddedByApp ? true : false,
      //       patientTerm: appt?.data?.term || '',
      //       ...(typeof appt?.data?.patientSeen === 'boolean' && {
      //         patientSeen: appt.data.patientSeen,
      //         notSeenReason: appt.data.notSeenReason,
      //       }),
      //     }
      //   }),
      // )

      // // Filter out nulls and unwanted noteStatus
      // updatedPatients = updatedPatients.filter((item) => item && (item.noteStatus === 'Submitted' || (item.noteFlag === 'true' && item.noteStatus === 'Draft')))

      const nestedStructure = {}
      const imagingTypeList = (await getImagingDetailsAllMaster()) || []
      incrementProgress()

      await Promise.all(
        updatedPatients.map(async (patient) => {
          const providerId = loggedUserProvider?.ID
          if (!nestedStructure[providerId]) nestedStructure[providerId] = {}

          const lastNote = patient?.allNotes?.[patient?.allNotes.length - 1] || {}
          let parsedNoteData = {}

          // imaginggs fetching and formatting
          let imagings = []
          let formattedData = await PatientImagingsCRUD('GET', patient?.PatientID?.toString())
          if (formattedData) {
            formattedData = JSON.parse(formattedData.d)
            formattedData = formattedData.Data.map((item) => {
              const parsedData = JSON.parse(item.data)
              const matchingType = parsedData && imagingTypeList.find((type) => type.Name.toString() === parsedData.name.toString())
              incrementProgress()
              return {
                ...item,
                data: {
                  ...parsedData,
                  keywords: matchingType ? extractUniqueKeywords(matchingType.Keywords) : [],
                },
              }
            }).sort((a, b) => new Date(b?.date) - new Date(a?.date))
            imagings = formattedData
          }

          try {
            parsedNoteData = typeof lastNote?.data === 'string' ? JSON.parse(lastNote.data) : lastNote?.data || {}
          } catch (err) {
            parsedNoteData = {}
          }

          // medication fetching and formatting
          let formattedDataMeds
          const masterMedications = (await getMedicationMasterData()) || []
          const responseMed = await PatientMedications('GET', patient?.PatientID?.toString())
          incrementProgress()
          formattedDataMeds = JSON.parse(responseMed?.d)
          formattedDataMeds = formattedDataMeds?.Data

          const masterMedsNames = masterMedications.map((med) => med.Data?.name?.toLowerCase())

          if (formattedDataMeds) {
            formattedDataMeds = formattedDataMeds.map((item) => {
              let parsedData = []
              try {
                parsedData = item.data ? JSON.parse(item.data) : []
              } catch (e) {
                console.error('Error parsing item.data:', e, item.data)
              }

              const updatedData = Array.isArray(parsedData)
                ? parsedData.map((med) => ({
                    ...med,
                    inMaster: masterMedsNames.includes(med?.name?.toLowerCase()),
                  }))
                : []
              updatedData.sort((a, b) => (a.inMaster === b.inMaster ? 0 : a.inMaster ? -1 : 1))

              return {
                ...item,
                data: updatedData,
              }
            })
          }

          formattedDataMeds.sort((a, b) => new Date(b?.date) - new Date(a?.date))

          // Orders fetching and formatting
          let dataOrders = await PatientOrdersCRUD('Get', '', patient?.PatientID)
          incrementProgress()

          dataOrders = JSON.parse(dataOrders?.d).Data || []
          const parsedOrders = dataOrders?.map((order) => {
            let parsedDataMeds = []
            try {
              parsedDataMeds = order.medication ? JSON.parse(order.medication) : []
            } catch (e) {
              console.error('Error parsing order.data:', e, order.data)
            }
            return {
              id: order.id,
              date: order.date,
              medication: parsedDataMeds,
            }
          })
          // .filter((item) => item.medication?.noteID === parseInt(noteID) - 1)

          let tempAnswersGetPatientDiagnosisDetails = await GetPatientDiagnosisDetails(patient?.PatientID)
          incrementProgress()

          const intenalNotes = await getPatientInternalNotes(patient.PatientID)
          incrementProgress()
          const hospitalRecords = await getHospitalRecord(patient.PatientID)
          incrementProgress()
          const patientHistories = await getDataPersonalHistoryInNote(patient.PatientID)
          incrementProgress()
          const patientAllergy = await getPatientAllergy(patient.PatientID)
          incrementProgress()
          const patientVitals = await getPatientVitals(patient.PatientID)
          incrementProgress()
          const labData = await fetchPatientLabs(patient.PatientID)
          incrementProgress()
          const PEPatientData = await getPatientPhysicalExamination(patient.PatientID)
          incrementProgress()
          const patientSuperBill = await getPatientSuperBill(patient.PatientID)
          incrementProgress()

          const threeSections = ['Labs', 'Medication', 'Imaging', 'Miscellaneous']
          const formattedDataReport = {
            // [oneofsection] : data
          }

          for (const sections of threeSections) {
            let formattedData
            formattedData = await PatientReportCRUD('GET', patient?.PatientID?.toString(), '', sections.toString())

            if (formattedData) {
              formattedData = JSON.parse(formattedData.d)?.Data
              formattedData = formattedData.map((item) => {
                return {
                  ...item,
                  data: JSON.parse(item.data),
                }
              })
            }

            formattedDataReport[sections] = formattedData || []
          }
          incrementProgress()

          let diagnosisDataIndexed = await ModifyPatientMap('GETALL', patient?.PatientID, '')
          let tempData = JSON.parse(diagnosisDataIndexed.d)?.Data

          diagnosisDataIndexed = tempData.filter((obj) => {
            if (patient?.PatientID == obj.PatientID) {
              return obj
            }
          })
          incrementProgress()

          nestedStructure[providerId][patient.PatientID] = {
            details: patient.patientData,
            currentNote: {
              ...lastNote,
              data: parsedNoteData,
            },
            tempAnswersGetPatientDiagnosisDetails,
            appointmentData: patient.appointmentData,
            appointmentId: patient.appointmentID,
            totalNotes: patient.allNotes.length || 0,
            allImaging: imagings || [],
            ordersData: parsedOrders || [],
            allMedications: formattedDataMeds || [],
            interNote: intenalNotes || [],
            isFirstNote: patient.allNotes.length === 0,
            allNotes: patient.allNotes || [],
            isDetailsSyncedWithServer: false,
            hospitalRecords: hospitalRecords || [],
            patientHistories: patientHistories || {},
            patientAllergy: patientAllergy,
            patientVitals: patientVitals,
            patientLabData: labData,
            PEPatientData: PEPatientData,
            reportData: formattedDataReport,
            patientSuperBill: patientSuperBill,
            patientData: patient,
            diagnosisDataModifyMap: diagnosisDataIndexed || [],
          }
        }),
      )

      await checkIfMastersExist()
      // await saveOfflineData(nestedStructure)
      await saveOpenChartOfflineData(nestedStructure)
      // setAppointmentProgress(100)
      // setFilteredPatientData(updatedPatients)

      //  setIsRefreshLoad(false)
      // toast.success('All appointments data synced successfully', toastConfig);
    } catch (error) {
      console.error('Error fetching patient treatments', error)
      // setIsRefreshLoad(false)
    }
  }

  const [showOverwriteModal, setShowOverwriteModal] = useState(false)
  const [isAllowDownloading, setIsAllowDownloading] = useState(false)

  const normalizePatientId = (patientId) => {
    if (patientId === undefined || patientId === null || patientId === '') return null
    return patientId.toString()
  }

  const parseCachedAppointmentList = (cachedData) => {
    if (!cachedData) return []
    if (Array.isArray(cachedData)) return cachedData

    if (typeof cachedData === 'string') {
      try {
        const parsedData = JSON.parse(cachedData)
        return Array.isArray(parsedData) ? parsedData : []
      } catch (error) {
        return []
      }
    }

    return []
  }

  const getPatientIdFromCacheItem = (item) =>
    normalizePatientId(
      item?.PatientID ??
        item?.patientData?.PatientID ??
        item?.details?.PatientID ??
        item?.appointmentData?.PatientID ??
        item?.newlyAddedData?.currentNote?.patientID ??
        item?.currentNote?.patientID,
    )

  const getPreSignedPatientIds = async () => {
    const preSignedPatientIds = new Set()
    const cachedPreSignedAppointment = await getPreSignedAppointment()
    const parsedPreSignedAppointment = parseCachedAppointmentList(cachedPreSignedAppointment)

    parsedPreSignedAppointment.forEach((item) => {
      const patientId = getPatientIdFromCacheItem(item)
      if (patientId) preSignedPatientIds.add(patientId)
    })

    const preSignedData = (await getPreSignedData()) || {}

    Object.values(preSignedData || {}).forEach((providerPatients) => {
      Object.entries(providerPatients || {}).forEach(([patientIdKey, patientData]) => {
        const patientId = getPatientIdFromCacheItem(patientData) || normalizePatientId(patientIdKey)
        if (patientId) preSignedPatientIds.add(patientId)
      })
    })

    return preSignedPatientIds
  }

  const pruneOpenChartCache = async (activePatientIds, preSignedPatientIds = new Set()) => {
    if (!(activePatientIds instanceof Set)) return

    const shouldKeepPatient = (patientId) => patientId && activePatientIds.has(patientId) && !preSignedPatientIds.has(patientId)
    const cachedNotesData = await getOpenChartAppointmentData()
    const parsedNotes = parseCachedAppointmentList(cachedNotesData)
    const filteredNotes = parsedNotes.filter((item) => shouldKeepPatient(getPatientIdFromCacheItem(item)))

    if (filteredNotes.length !== parsedNotes.length) {
      await saveOpenChartAppointmentData(JSON.stringify(filteredNotes))
      setFilteredPatientData((prev) => (Array.isArray(prev) ? prev.filter((item) => shouldKeepPatient(getPatientIdFromCacheItem(item))) : prev))
    }

    const openChartOfflineData = await getOpenChartOfflineData()
    const loggedProvider = await getProviderDetails()
    const loggedProviderId = loggedProvider?.ID

    if (!openChartOfflineData || !loggedProviderId) return

    const providerData = openChartOfflineData?.[loggedProviderId] || {}
    const updatedProviderData = {}
    let hasRemovedPatient = false

    Object.entries(providerData || {}).forEach(([patientIdKey, patientData]) => {
      const patientId = getPatientIdFromCacheItem(patientData) || normalizePatientId(patientIdKey)

      if (shouldKeepPatient(patientId)) {
        updatedProviderData[patientIdKey] = patientData
      } else {
        hasRemovedPatient = true
      }
    })

    if (hasRemovedPatient) {
      await saveOpenChartOfflineData({
        ...openChartOfflineData,
        [loggedProviderId]: updatedProviderData,
      })
    }
  }

  const prepareOpenChartRefreshContext = async () => {
    const latesDataAppointment = await getLatestDataPatientDataFn()
    const activePatientIds = new Set((latesDataAppointment?.schedulePatient || []).map((patient) => normalizePatientId(patient?.PatientID)).filter(Boolean))
    const preSignedPatientIds = await getPreSignedPatientIds()

    if (Array.isArray(latesDataAppointment?.schedulePatient)) {
      await pruneOpenChartCache(activePatientIds, preSignedPatientIds)
    }

    return {
      latesDataAppointment,
      preSignedPatientIds,
    }
  }

  const checkUploadPatient = async () => {
    const getProviderDetailsData = await getProviderDetails()
    // const data = await getOfflineData()
    const data = await getOpenChartOfflineData()
    if (!data) {
      return true
    }
    const DBData = data[getProviderDetailsData?.ID] || []

    // const signedPatients = Object.values(DBData)?.filter((item) => item?.newlyAddedData?.currentNote?.status === 'Signed' && !item?.isUploaded)
    const signedPatients = Object.values(DBData).filter((item) => item?.newlyAddedData || item?.saveDraft === true)
    if (signedPatients.length > 0) {
      return false
    } else {
      return true
    }
  }

  const getLoggedUserId = async () => {
    try {
      let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
      providerData = JSON.parse(providerData.d)?.Data
      const getUser = JSON.parse(localStorage.getItem('user'))

      const foundProvider = providerData.find((obj) => obj.UserId === getUser?.Username)
      return foundProvider || null
    } catch (error) {
      console.log(error)
    }
  }

  const getLatestAppointmentData = async () => {
    try {
      const providerId = await getLoggedUserId()
      const appointmentDetails = await getAllAppointmentsDetails('GETBYPROVIDERID', '', providerId?.ID)

      return appointmentDetails
    } catch (error) {
      console.log('Error in getAppointmentData', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const getLatestDataPatientDataFn = async () => {
    // setIsPageLoading(true)
    try {
      let patientData = await SavePatients('GetAll', '', '', '')
      let patient = JSON.parse(patientData.d).Data
      let appointments = await getLatestAppointmentData()
      let schedulePatient = patient?.filter((patient, index) => appointments.find((item) => item.current.Patient.value === patient.PatientID))
      return {
        schedulePatient,
        appointments,
      }
    } catch (error) {
      console.log(error)
    } finally {
      // setIsPageLoading(false)
    }
  }

  const handleDownloadClick = async () => {
    let refreshContext = null

    try {
      refreshContext = await prepareOpenChartRefreshContext()
    } catch (error) {
      console.error('Error preparing open chart refresh', error)
    }

    const canProceed = await checkUploadPatient()

    if (!canProceed) {
      setShowOverwriteModal(true)
      return
    }

    // directly allow download
    GetPatientTreatmentsNotes(refreshContext)
  }

  const GetPatientTreatmentsNotes = async (refreshContext = null) => {
    // const isShowRefresh = await handleDownloadClick()
    // if (!isShowRefresh) {

    //   return toast.error('Please upload all the signed patients before downloading.', toastConfig)
    // }
    setAppointmentProgress(0)
    setIsRefreshLoad(true)

    let latesDataAppointment = refreshContext?.latesDataAppointment
    let preSignedPatientIds = refreshContext?.preSignedPatientIds

    if (!latesDataAppointment || !(preSignedPatientIds instanceof Set)) {
      const preparedRefreshContext = await prepareOpenChartRefreshContext()
      latesDataAppointment = preparedRefreshContext?.latesDataAppointment
      preSignedPatientIds = preparedRefreshContext?.preSignedPatientIds
    }

    const patientData = latesDataAppointment?.schedulePatient
    const appointment = latesDataAppointment?.appointments
    if (!patientData || !appointment) {
      toast.error('Unable to load patient data. Please download the patient again.', toastConfig)
      setIsRefreshLoad(false)
      return
    }

    try {
      let updatedPatients = await Promise.all(
        appointment.map(async (appt) => {
          const appointmentPatientId = normalizePatientId(appt?.data?.PatientID)

          if (preSignedPatientIds?.has(appointmentPatientId)) return null

          const patient = patientData.find((p) => normalizePatientId(p.PatientID) === appointmentPatientId)
          if (!patient) return null

          if (!appt?.data?.NoteID) {
            return
          }
          let status = patient.noteStatus || 'Not Created'
          let flag = 'false'

          let parsedData = []
          try {
            const dataResponse = await PatientNoteDataCRUD('GET', patient.PatientID)
            parsedData = JSON.parse(dataResponse?.d)?.Data || []
            if (parsedData.length > 0) {
              const lastNote = parsedData[parsedData.length - 1]
              status = lastNote?.status || status
              flag = lastNote?.flag || 'false'
            }
          } catch (err) {
            console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
          }

          const scheduleStatus = appt?.data?.Status
          const scheduleBy = appt?.data?.ScheduleBy
          const type = appt?.data?.Type
          const isInFacility = appt?.data?.isInFacility
          const priorAuth = appt?.data?.otherDetails?.priorAuth?.isRequired
          const noteSeen = appt?.data?.patientSeen
          let priorAuthTime = 0

          if (priorAuth) {
            priorAuthTime = parseInt(appt?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
          }

          const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)

          const isScheduledOrRescheduled = (scheduleStatus === 'Scheduled' && noteSeen !== false) || (scheduleStatus === 'Rescheduled' && noteSeen !== false)

          if (!(isScheduledOrRescheduled && isManualOrFollowUp)) return null

          const providerName = appt?.current?.Provider?.label
          const scheduleDate = appt?.data?.StartTime?.split(' ')[0]

          const isProviderAppointment = providerName === loggedUserProvider?.Name
          if (!isProviderAppointment) return null

          // return {
          //   ...patient,
          //   noteStatus: status,
          //   noteFlag: flag,
          //   appointmentScheduleDate: scheduleDate,
          //   appointmentID: appt?.data?.AppointmentID,
          //   patientTerm: appt?.data?.term || '',
          //   ...(typeof appt?.data?.patientSeen === 'boolean' && {
          //     patientSeen: appt.data.patientSeen,
          //     notSeenReason: appt.data.notSeenReason,
          //   }),
          // }

          return {
            ...patient,
            patientData: patient,
            noteStatus: status,
            noteFlag: flag,
            appointmentData: appt?.data,
            allNotes: parsedData,
            appointmentScheduleDate: scheduleDate,
            appointmentID: appt?.data?.AppointmentID,
            AddedByApp: appt?.data?.AddedByApp ? true : false,
            patientTerm: appt?.data?.term || '',
            facilityParentCompany: getPatientFacilityParentCompany({ ...patient, ...appt }, facilities),
            ...(typeof appt?.data?.patientSeen === 'boolean' && {
              patientSeen: appt.data.patientSeen,
              notSeenReason: appt.data.notSeenReason,
            }),
          }
        }),
      )
      updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag === 'true' && item?.noteStatus === 'Draft'))
      updatedPatients = updatedPatients.filter((item) => !preSignedPatientIds?.has(getPatientIdFromCacheItem(item)))
      const today = new Date()
      const formattedToday = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`

      updatedPatients = updatedPatients.filter((item) => {
        const isNotScheduledToday = item?.appointmentScheduleDate !== formattedToday
        const matchesNoteCondition = item?.noteStatus === 'Submitted' || (item?.noteFlag === 'true' && item?.noteStatus === 'Draft')

        return isNotScheduledToday && matchesNoteCondition
        //  return   matchesNoteCondition
      })

      const allAppointmentData = await PatientAppointmentDetails('GET', '', '', '', '')
      const allAppointmentDetails = await getAllAppointmentsDetails('GET')

      // localStorage.setItem('patientTreatmentsNotes', JSON.stringify(updatedPatients))
      // if (isShowRefresh) {
      //   //  localStorage.setItem('patientTreatmentsNotes', JSON.stringify(updatedPatients))
      //   await saveOpenChartAppointmentData(JSON.stringify(updatedPatients))
      //   await GetAppointmentsAllDataInDb(updatedPatients)
      //   setFilteredPatientData(updatedPatients)
      // } else {
      //   toast.error('Please upload all the signed patients before downloading.', toastConfig)
      // }
      await saveAllAppointmentData(allAppointmentData)
      await saveAllAppointmentDetails(allAppointmentDetails)
      await saveOpenChartAppointmentData(JSON.stringify(updatedPatients))
      await GetAppointmentsAllDataInDb(updatedPatients)
      setFilteredPatientData(updatedPatients)

      setAppointmentProgress(100)
      localStorage.setItem('isRefreshedToday', new Date().toISOString())
      setIsRefreshedToday(true)
      setIsRefreshLoad(false)
    } catch (error) {
      console.error('Error fetching patient treatments', error)

      setIsRefreshLoad(false)
      // toast.error('Error in patient treatment', toastConfig)
    }
  }

  const GetPatientTreatmentsNotesold = async () => {
    setIsRefreshLoad(true)
    if (!patientData) return

    try {
      let updatedPatients = await Promise.all(
        patientData.map(async (patient) => {
          let status = patient.noteStatus || 'Not Created' // Default status
          let flag = 'false' // Default flag

          try {
            const dataResponse = await PatientNoteDataCRUD('GET', patient?.PatientID)
            const parsedData = JSON.parse(dataResponse?.d)?.Data

            if (Array.isArray(parsedData) && parsedData.length > 0) {
              status = parsedData[parsedData.length - 1]?.status || status
              flag = parsedData[parsedData.length - 1]?.flag || 'false'
            }
          } catch (err) {
            console.error(`Error fetching notes for patient ${patient?.PatientID}:`, err)
          }

          const patientAppointments = appointment.filter((item) => item.current.Patient.value === patient.PatientID)

          const scheduledAppointment = patientAppointments.find((p) => {
            const status = p?.data?.Status
            const scheduleBy = p?.data?.ScheduleBy
            const type = p?.data?.Type
            const isInFacility = p?.data?.isInFacility
            const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
            const noteSeen = p?.data?.patientSeen
            let priorAuthTime = 0
            if (priorAuth) {
              priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
            }

            const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)

            // const isScheduledOrRescheduled = (status === 'Scheduled'  ) || (status === 'Rescheduled'  )
            const isScheduledOrRescheduled = (status === 'Scheduled' && noteSeen !== false) || (status === 'Rescheduled' && noteSeen !== false)

            return isScheduledOrRescheduled && isManualOrFollowUp
          })

          if (!scheduledAppointment) return null

          const providerName = scheduledAppointment?.current?.Provider?.label
          const scheduleDate = scheduledAppointment?.data?.StartTime?.split(' ')[0]

          const isProviderAppointment = providerName === loggedUserProvider?.Name

          if (!isProviderAppointment) return null

          return {
            ...patient,
            noteStatus: status,
            noteFlag: flag,
            appointmentScheduleDate: scheduleDate,
            patientTerm: scheduledAppointment?.data?.term || '',
            ...(typeof scheduledAppointment?.data?.patientSeen === 'boolean' && {
              patientSeen: scheduledAppointment.data.patientSeen,
              notSeenReason: scheduledAppointment.data.notSeenReason,
            }),
          }
        }),
      )

      updatedPatients = updatedPatients.filter((item) => item?.noteStatus === 'Submitted' || (item?.noteFlag === 'true' && item?.noteStatus === 'Draft'))

      // const today = new Date()
      // const formattedToday = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`

      // updatedPatients = updatedPatients.filter((item) => {
      //   const isNotScheduledToday = item?.appointmentScheduleDate !== formattedToday
      //   const matchesNoteCondition = item?.noteStatus === 'Submitted' || (item?.noteFlag === 'true' && item?.noteStatus === 'Draft')

      //   return isNotScheduledToday && matchesNoteCondition
      // })

      localStorage.setItem('patientTreatmentsNotes', JSON.stringify(updatedPatients))

      setFilteredPatientData(updatedPatients)
      setIsRefreshLoad(false)
    } catch (error) {
      setIsRefreshLoad(false)
    }
  }
  useEffect(() => {
    const loadNotes = async () => {
      setIsPageLoading(true)

      // const cachedNotesData = localStorage.getItem('patientTreatmentsNotes')
      const cachedNotesData = await getOpenChartAppointmentData()

      if (cachedNotesData && refreshCounter === 0) {
        try {
          const parsedNotes = JSON.parse(cachedNotesData)

          if (parsedNotes) {
            setFilteredPatientData(parsedNotes)
          } else {
            // await GetPatientTreatmentsNotes()
          }
        } catch (err) {
          console.warn('Invalid cache data, fetching fresh data...')
          // await GetPatientTreatmentsNotes()
        }

        setIsPageLoading(false)
      }
      //  else {
      //   await GetPatientTreatmentsNotes()
      //   setIsPageLoading(false)
      // }
    }

    loadNotes()
  }, [patientData, loggedUserProvider, refreshCounter])

  const downLoadTodaysPatient = () => {
    setIsPageLoading(true)
    handleDownloadClick()
    // GetPatientTreatmentsNotes()
    setIsPageLoading(false)
  }

  const [groupedUpdatedFilteredPatients, setGroupedUpdatedFilteredPatients] = useState([])
  const [updatedFilteredPatients, setUpdatedFilteredPatients] = useState([])

  // useEffect(() => {
  //   const runFiltering = () => {
  //     const selectedFacilityLabels = facilities.filter((facility) => filterData.facility.includes(facility.value)).map((facility) => facility.label)

  //     const allFltered =
  //       filteredPatientData?.filter((patient) => {
  //         const matchesFacility = filterData.facility.length === 0 || selectedFacilityLabels.includes(patient.FacilityName)

  //         const matchesStatus = filterData.status.length === 0 || filterData.status.includes(patient.Status)

  //         const matchesSearchValue = !filterData.searchValue || patient?.FirstName.toLowerCase().includes(filterData.searchValue.toLowerCase()) || patient?.FacilityName.toLowerCase().includes(filterData.searchValue.toLowerCase())

  //         const matchesSchedule = !filterData.scheduleDate || patient?.appointmentScheduleDate?.split?.(' ')?.[0] === filterData.scheduleDate

  //         const matchesDate = !filterData.date || patient?.DOB === filterData.date

  //         return matchesFacility && matchesStatus && matchesSearchValue && matchesDate && matchesSchedule
  //       }) || []

  //     const groupedByDate = allFltered.reduce((acc, patient) => {
  //       const date = patient.appointmentScheduleDate
  //       const facility = patient.FacilityName

  //       if (!acc[date]) acc[date] = {}
  //       if (!acc[date][facility]) acc[date][facility] = []
  //       acc[date][facility].push(patient)

  //       return acc
  //     }, {})

  //     const sortedGroupedByDate = Object.fromEntries(
  //       Object.entries(groupedByDate).sort(([a], [b]) => {
  //         const [am, ad, ay] = a.split('/')
  //         const [bm, bd, by] = b.split('/')

  //         const dateA = new Date(`${ay}-${am}-${ad}`)
  //         const dateB = new Date(`${by}-${bm}-${bd}`)

  //         return dateB - dateA
  //       }),
  //     )

  //     const patientInfoCount = {
  //       followUp: allFltered.filter((item) => item?.Status === 'Follow Up').length,
  //       newPatient: allFltered.filter((item) => item?.Status === 'NewPatient').length,
  //     }

  //     return { allFltered, sortedGroupedByDate, patientInfoCount }
  //   }

  //   const cacheKey = `filteredPatients_${JSON.stringify(filterData)}`

  //   setIsPageLoading(true)

  //   const useCache = refreshCounter === 0
  //   const cached = useCache ? localStorage.getItem(cacheKey) : null

  //   if (cached) {
  //     const parsedCache = JSON.parse(cached)
  //     setGroupedUpdatedFilteredPatients(parsedCache.sortedGroupedByDate)
  //     setUpdatedFilteredPatients(parsedCache.allFltered)
  //     setPatientCount(parsedCache.allFltered.length)
  //     setPatientInfoCount(parsedCache.patientInfoCount)
  //     setIsPageLoading(false)
  //     return
  //   }

  //   const { allFltered, sortedGroupedByDate, patientInfoCount } = runFiltering()

  //   setGroupedUpdatedFilteredPatients(sortedGroupedByDate)
  //   setUpdatedFilteredPatients(allFltered)
  //   setPatientCount(allFltered.length)
  //   setPatientInfoCount(patientInfoCount)
  //   localStorage.setItem(cacheKey, JSON.stringify({ allFltered, sortedGroupedByDate, patientInfoCount }))
  //   setIsPageLoading(false)
  // }, [filteredPatientData, filterData, facilities, refreshCounter])

  useEffect(() => {
    setIsPageLoading(true)

    const allFltered =
      filteredPatientData &&
      filteredPatientData
        .map((patient) => ({
          ...patient,
          facilityParentCompany: getPatientFacilityParentCompany(patient, facilities),
        }))
        .filter((patient) => {
          const selectedFacilityLabels = facilities.filter((facility) => filterData.facility.includes(facility.value)).map((facility) => facility.label)

          const matchesFacility = filterData.facility.length === 0 || selectedFacilityLabels.includes(patient.FacilityName)

          const matchesStatus = filterData.status.length === 0 || filterData.status.includes(patient.Status)

          const patientParentCompany = getPatientFacilityParentCompany(patient, facilities)
          const matchesSearchValue =
            !filterData.searchValue ||
            patientMatchesSearch(patient, filterData.searchValue, {
              facilityName: patient?.FacilityName,
              facilityParentCompany: patientParentCompany,
            })

          const matchesSchedule = !filterData.scheduleDate || patient?.appointmentScheduleDate?.split?.(' ')?.[0] === filterData.scheduleDate

          const matchesDate = !filterData.date || patient?.DOB === filterData.date

          return matchesFacility && matchesStatus && matchesSearchValue && matchesDate && matchesSchedule
        })

    const groupedByDate = {}

    const today = new Date()
    const todayKey = `${String(today.getMonth() + 1).padStart(2, '0')}/${String(today.getDate()).padStart(2, '0')}/${today.getFullYear()}`

    allFltered.forEach((patient) => {
      const date = patient.appointmentScheduleDate
      if (date === todayKey) return
      const facility = patient.FacilityName

      if (!groupedByDate[date]) {
        groupedByDate[date] = {}
      }

      if (!groupedByDate[date][facility]) {
        groupedByDate[date][facility] = []
      }

      groupedByDate[date][facility].push(patient)
    })
    // const sortedGroupedByDate = Object.fromEntries(Object.entries(groupedByDate).sort(([a], [b]) => new Date(b) - new Date()))
    const sortedGroupedByDate = Object.fromEntries(
      Object.entries(groupedByDate).sort(([a], [b]) => {
        const [am, ad, ay] = a.split('/')
        const [bm, bd, by] = b.split('/')

        const dateA = new Date(`${ay}-${am}-${ad}`)
        const dateB = new Date(`${by}-${bm}-${bd}`)

        return dateB - dateA
      }),
    )
    setGroupedUpdatedFilteredPatients(sortedGroupedByDate)
    setUpdatedFilteredPatients(allFltered)
    setPatientCount(allFltered?.length)
    setPatientInfoCount({
      followUp: allFltered.filter((item) => item?.Status === 'Follow Up').length,
      newPatient: allFltered.filter((item) => item?.Status === 'NewPatient').length,
    })
    setIsPageLoading(false)
  }, [filteredPatientData, filterData, facilities])

  // Patient Appointments
  const [showPatientAppointmentId, setShowPatientAppointmentId] = useState(null)
  const [patientAppointment, setPatientAppointment] = useState([])
  const [activeKey, setActiveKey] = useState(1)
  const [activeKeyTab, setActiveKeyTab] = useState(1)

  const GetSelectedPatientAppoint = async () => {
    try {
      const selectedAppointments = appointment.filter((appoint) => appoint?.data?.PatientID === showPatientAppointmentId)
      setPatientAppointment(selectedAppointments)
    } catch (error) {
      console.error('Error fetching patient appointments:', error)
      toast.error('Error fetching patient appointments', toastConfig)
    }
  }

  // const handleAppointmentSubmit = async () => {
  //     try {

  //         let appointmentFilterData = appointments.filter(item => (item.data.AppointmentID !== appointmentID))
  //         await SaveExtra('Update', 'AppointmentsData', JSON.stringify(appointmentFilterData), appointmentDataID[0]?.Id);
  //          patientDataFn()

  //         if (cancelModel) {
  //             toast.success('Cancel Appointment Successfully', toastConfig)
  //         } else if(finishModel) {
  //             toast.success('Finish Appointment Successfully', toastConfig)
  //         }
  //         // toast.success('Cancel Appointment Successfully', toastConfig)
  //     } catch (error) {
  //         toast.error('Failed to save', toastConfig)
  //     } finally {
  // setIsPageLoading(false)
  //         setCancelModel(false)
  //         setFinishModel(false)
  //         setAppointmentID(null)
  //     }
  // }

  const handleAppointmentSubmit = async (type, appointmentID, patientId) => {
    try {
      // setIsPageLoading(true)
      const ChangeNoteStatus = handlePatientNote('Finished', appointmentID, patientId)
      const groupedData = []
      let appointmentFilterData = appointments.map((item) => {
        if (item.data.AppointmentID === appointmentID) {
          const now = new Date()
          const formattedEndDate = now
            .toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
            .replace(',', '')
          return {
            ...item,
            data: {
              ...item.data,
              Status: type,
              EndTimezone: formattedEndDate,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()
      if (cancelModel) {
        toast.success('Finish Appointment Successfully', toastConfig)
      } else {
        // toast.success('Finish Appointment Successfully', toastConfig)
      }
      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      // setIsPageLoading(false)
      setCancelModel(false)
      setFinishModel(false)
      setAppointmentID(null)
    }
  }

  const handleDeleteSubmit = async () => {
    try {
      // setIsPageLoading(true)
      const DeleteNote = deletePatientNote(appointmentID, patientId)
      const groupedData = []
      let appointmentFilterData = appointments.filter((item) => item.data.AppointmentID !== appointmentID)

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()
      toast.success('Delete Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      // setIsPageLoading(false)
      setDeleteModel(false)
      setAppointmentID(null)
      setPatientID(null)
    }
  }

  const handleAppointmentCancel = async (type) => {
    try {
      // setIsPageLoading(true)
      const ChangeNoteStatus = handlePatientNote('Canceled', appointmentID, patientId)
      const groupedData = []
      let appointmentFilterData = appointments.map((item) => {
        if (item.data.AppointmentID === appointmentID) {
          const now = new Date()
          const formattedEndDate = now
            .toLocaleString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false,
            })
            .replace(',', '')
          return {
            ...item,
            data: {
              ...item.data,
              Status: type,
              EndTimezone: formattedEndDate,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()
      toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      // setIsPageLoading(false)
      setCancelModel(false)
      setFinishModel(false)
      setAppointmentID(null)
    }
  }

  const handleAddNoteId = async (noteID) => {
    try {
      // setIsPageLoading(true)

      const groupedData = []
      let appointmentFilterData = appointments.map((item) => {
        if (item.data.AppointmentID === patientAppointmentID) {
          return {
            ...item,
            data: {
              ...item.data,
              NoteID: noteID,
            },
          }
        }
        return item
      })

      appointmentFilterData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      getAppointmentData()
      patientDataFn()

      // toast.success('Cancel Appointment Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save Note Id', toastConfig)
    } finally {
      // setIsPageLoading(false)
      setPatientAppointment(null)
    }
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const handlePatientNote = async (type, appointmentID, patientId) => {
    try {
      if (!appointmentID || !patientId) {
        throw new Error('Missing appointmentId or patientId.')
      }

      const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)

      if (appointmentFilterData.length === 0) {
        throw new Error(`No appointment found with ID: ${appointmentID}`)
      }

      const noteID = appointmentFilterData[0]?.data?.NoteID

      if (!noteID) {
        throw new Error(`NoteID not found for appointment ID: ${appointmentID}`)
      }

      const dataResponse = await PatientNoteDataCRUD('GET', patientId)

      if (!dataResponse?.d) {
        throw new Error('No data received from PatientNoteDataCRUD GET.')
      }

      const parsedResponse = JSON.parse(dataResponse.d)
      const parsedData = parsedResponse?.Data

      if (!Array.isArray(parsedData)) {
        throw new Error('Parsed patient data is not a valid array.')
      }

      const findNote = parsedData.filter((item) => item.id === noteID)

      if (findNote.length === 0) {
        throw new Error(`No patient note found with ID: ${noteID}`)
      }

      const treatmentData = findNote[0]
      const id = treatmentData?.id

      if (!id) {
        throw new Error('Note ID is missing in the matched note.')
      }

      let data = {}

      try {
        data = treatmentData?.data ? JSON.parse(treatmentData.data) : {}
      } catch (e) {
        console.error('Invalid JSON in treatmentData.data:', e)
        data = {}
      }

      if (type === 'Canceled') {
        data.NoteCancelReason = cancelReason
      }

      await PatientNoteDataCRUD('UPDATE', patientId.toString(), id.toString(), JSON.stringify(data), getFormattedDate().toString(), type, 'true')

      setCancelReason('')
    } catch (err) {
      console.error('Error in handlePatientNote:', err.message || err)
      setCancelReason('')
    }
  }

  const deletePatientNote = async (appointmentID, patientId) => {
    try {
      if (!appointmentID || !patientId) {
        throw new Error('Missing appointmentId or patientId.')
      }

      const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)

      if (appointmentFilterData.length === 0) {
        throw new Error(`No appointment found with ID: ${appointmentID}`)
      }

      const noteID = appointmentFilterData[0]?.data?.NoteID

      if (!noteID) {
        throw new Error(`NoteID not found for appointment ID: ${appointmentID}`)
      }

      const dataResponse = await PatientNoteDataCRUD('GET', patientId)

      if (!dataResponse?.d) {
        throw new Error('No data received from PatientNoteDataCRUD GET.')
      }

      const parsedResponse = JSON.parse(dataResponse.d)
      const parsedData = parsedResponse?.Data

      if (!Array.isArray(parsedData)) {
        throw new Error('Parsed patient data is not a valid array.')
      }

      const findNote = parsedData.filter((item) => item.id === noteID)

      if (findNote.length === 0) {
        throw new Error(`No patient note found with ID: ${noteID}`)
      }

      await PatientNoteDataCRUD('DELETE', patientID.toString(), noteID.toString())
    } catch (err) {
      console.error('Error in patient delete:', err.message || err)
    }
  }

  const getFacilitiesAppointment = async () => {
    let facilities = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(facilities.d)

    facilities = data.Data
    facilities = facilities.filter((obj) => {
      if (obj.Days && obj.Days != '') {
        return obj
      }
    })
    setLocations(facilities)
  }

  function formatDate(date) {
    const mm = String(date.getMonth() + 1).padStart(2, '0')
    const dd = String(date.getDate()).padStart(2, '0')
    const yyyy = String(date.getFullYear())
    const hh = String(date.getHours()).padStart(2, '0')
    const min = String(date.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  const handleAppointment = (appointmentID, type, patientId, patient) => {
    if (type === 'cancel') {
      setCancelModel(true)
    } else if (type === 'finish') {
      getSuperBillData(patientId)
      handleAppointmentSubmit('Finish', appointmentID, patientId)
      setTimeout(() => {
        handleAutoSchedule(patient, appointmentID)
      }, 1000)
    } else if (type === 'delete') {
      setDeleteModel(true)
    }

    setAppointmentID(appointmentID)
    setPatientId(patientId)
    setSuperBill([])
  }

  const handleSubmit = async (updateData) => {
    try {
      // setIsPageLoading(true)

      const groupedData = []

      updateData.forEach((entry) => {
        const patientID = entry.current.Patient.value

        const existing = groupedData.find((item) => item.patientID === patientID)

        if (existing) {
          existing.appointmentDetails.push({ data: entry.data, current: entry.current })
        } else {
          groupedData.push({
            patientID,
            appointmentDetails: [{ data: entry.data, current: entry.current }],
          })
        }
      })

      await SaveExtra('Update', 'multiAppointmentsData', JSON.stringify(groupedData), allAppointment[0]?.Id || 388)

      // getAppointmentData();
      getAppointmentData()
      patientDataFn()
      toast.success('Patient Auto Scheduled  Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to Auto Scheduled', toastConfig)
    } finally {
      // setIsPageLoading(false)
    }
  }

  const getAllProviderDetails = async (obj) => {
    const provider = {
      ID: obj.ID,
    }
    let providerData = await fetchPatientData('SELECTALL', 'Provider', JSON.stringify(provider))
    let insuranceData = JSON.parse(providerData.d)?.Insurance
    let facilityData = JSON.parse(providerData.d)?.Facility
    // setselectProviderInsurances(insuranceData)
    // setselectProviderFacilities(facilityData)

    obj['Insurances'] = insuranceData
    obj['Facilities'] = facilityData

    return obj
  }

  const getProviders = async () => {
    let providerData = await fetchPatientData('SELECT', 'Provider', '{}')
    let data = JSON.parse(providerData.d)
    providerData = data.Data
    let newProviders = []
    for (let i = 0; i < providerData.length; i++) {
      let c = await getAllProviderDetails(providerData[i])
      newProviders.push(c)
    }

    const daysMap = {}

    // Iterate through the providers array
    newProviders.forEach((provider) => {
      // Iterate through each facility of the provider
      provider.Facilities.forEach((facility) => {
        // Split the Days string into an array of days
        const daysArray = facility.Days.split(',')

        // For each day in the daysArray, add the provider to the corresponding entry in the map
        daysArray.forEach((day) => {
          day = day.trim()
          if (!daysMap[day]) {
            daysMap[day] = []
          }

          // Find if the provider already exists in the day's list
          let providerEntry = daysMap[day].find((p) => p.ID === provider.ID)
          if (!providerEntry) {
            // Add the provider if not already in the list for that day
            providerEntry = {
              ID: provider.ID,
              Name: provider.Name,
              Gender: provider.Gender,
              DOB: provider.DOB,
              Address: provider.Address,
              AddressDetails: provider.AddressDetails,
              Lat: provider.Lat,
              Lng: provider.Lng,
              Insurances: provider.Insurances,
              Facilities: [],
            }
            daysMap[day].push(providerEntry)
          }

          // Add the facility to the provider's list of facilities
          providerEntry.Facilities.push(facility)
        })
      })
    })

    setDaysMap(daysMap)
    return newProviders
  }

  const allData = useRef({})

  const handleSchedule = async (props, patient, oldData) => {
    if (!props?.StartTime || !props?.EndTime) return

    let scheduleAppointmentTime = await getSuperBillData(patient.PatientID)
    const weeksMatch = scheduleAppointmentTime?.match(/(\d+)\s*week/i)
    const weeksToAdd = weeksMatch ? parseInt(weeksMatch[1], 10) : 1
    let startTime = new Date(props.StartTime)
    let targetDate = new Date(startTime)
    targetDate.setDate(targetDate.getDate() + weeksToAdd * 7)
    const date = targetDate.toISOString().split('T')[0]
    const dayOptions = { weekday: 'long' }
    const day = targetDate.toLocaleDateString('en-US', dayOptions)

    try {
      const allDayData = daysMap[day]
      if (!allDayData) {
        console.warn(`No data found for ${day}.`)
        alert('No schedule available for this day.')
        return
      }

      allDayData.forEach((obj) => {
        obj.Facilities.forEach((facility) => {
          let tempFacility = locations.find((o) => o.ID == facility.FacilityID)
          facility['Name'] = tempFacility?.Name || ''
          facility['Type'] = tempFacility?.Type || ''
        })
      })

      const providerInfo = allDayData.filter((obj) => obj.Facilities.some((facility) => facility.Name === patient.FacilityName))

      if (providerInfo.length === 0) {
        console.warn(`No provider assigned to ${patient.FacilityName} on ${day}.`)
        alert('No providers are currently assigned to this facility on the selected day.')
        return
      } else {
        let provider = providerInfo.filter((item) => item?.ID === oldData?.current?.Provider?.value)
        if (provider.length === 0) {
          provider = providerInfo[0]
        } else {
          provider = provider[0]
        }
        allData.current.Provider = {
          value: provider?.ID,
          label: provider?.Name,
        }
        return targetDate
      }
    } catch (e) {
      console.error('Error processing schedule:', e)
    }
  }

  const handleAutoSchedule = async (item, appointmentID) => {
    const appointmentFilterData = appointments.filter((item) => item?.data?.AppointmentID === appointmentID)
    let patientInsurance = await PatientInsuranceFn('SELECT', '', item.PatientID)
    let tempAppointments = []
    let Insurance = {}
    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
      if (patientInsurance.length > 0) {
        Insurance = JSON.parse(patientInsurance[0].InsuranceDetails)
        Insurance = Insurance[0] || {}
      }
    } catch (e) {}
    try {
      let getPatientTime = await PatientNoteDataCRUD('GET', item.PatientID)
      getPatientTime = JSON.parse(getPatientTime.d)?.Data
      getPatientTime = getPatientTime.map((entry) => ({
        ...entry,
        getPatientTime: entry.getPatientTime ? JSON.parse(entry.getPatientTime) : {},
      }))
      if (getPatientTime) {
        let rawDate = getPatientTime.length > 0 ? getPatientTime[0].date : new Date().toISOString().split('T')[0]
        let formattedDate = rawDate.replaceAll('.', '/')

        let props = {
          StartTime: appointmentFilterData.length > 0 ? appointmentFilterData[0]?.data.StartTime : formattedDate,
          EndTime: formattedDate,
          PatientID: item.PatientID,
        }

        let filtered = await getAppointmentForAutoSchedule()

        let oldData
        if (filtered.length > 0) {
          // filtered = filtered.filter((entry) => entry.patientID === item.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Finish'))
          filtered = filtered.filter((entry) => entry.patientID === item.PatientID && entry.appointmentDetails.some((appt) => appt.data?.Status === 'Signed' || appt.data?.Status === 'Finish'))
          oldData = filtered[0].appointmentDetails.at(-1)
        }

        if (oldData?.data?.isInFacility === false) {
          alert(`Patient ${item.FirstName} ${item.LastName || ''} is not in the facility and cannot be scheduled.`)
          return
        }
        let updateOtherDetails = {}

        const priorAuth = oldData?.data?.otherDetails?.priorAuth.log('Updated priorAuth:', updateOtherDetails, priorAuth, oldData)
        if (priorAuth?.isRequired) {
          let noOfTimes = parseInt(priorAuth?.details?.noOfTimes, 10)

          if (isNaN(noOfTimes) || noOfTimes <= 0) {
            alert(`Patient ${item.FirstName} ${item.LastName || ''} has no remaining insurance and cannot be scheduled.`)
            if (oldData?.data) {
              oldData.data.isInFacility = false
            }
            return
          } else {
            updateOtherDetails = {
              ...oldData.data.otherDetails,
              priorAuth: {
                ...priorAuth,
                details: {
                  ...priorAuth.details,
                  noOfTimes: `${noOfTimes - 1}`,
                },
              },
            }
          }
        }

        let scheduledDate = await handleSchedule(props, item, oldData)
        let organizeDate = formatDate(scheduledDate)

        let facility = locations?.find((facility) => facility.Name === item.FacilityName)

        let localPatient = { value: item.PatientID, label: `${item.FirstName} ${item.LastName}` }
        let localFacility = { value: facility?.ID, label: facility?.Name }
        let localProvider = allData.current?.Provider || {}

        let data = {
          AppointmentName: `${item.FirstName} ${item.LastName}`,
          StartTime: organizeDate,
          EndTime: organizeDate.replace(':00', ':15').replace(':30', ':45'),
          PatientID: item.PatientID,
          StartTimezone: null,
          EndTimezone: null,
          Facility: facility?.Name || '',
          Insurance: Insurance || {},
          Status: 'Scheduled',
          Notes: '',
          RoomNumber: item.Room,
          RecurrenceRule: '',
          VisitReason: 'F/U (Follow Up)',
          isInFacility: oldData ? oldData?.data?.isInFacility || true : true,
          otherDetails: oldData ? updateOtherDetails || {} : {},
          AppointmentID: Date.now(),
          ProviderName: localProvider?.label || '',
          ScheduleBy: 'auto-manuel',
          // PatientStatus: filtered.length > 0 ? 'Follow Up' :  item?.Status || 'NewPatient'
          Type: 'Follow Up',
          CreatedDate: new Date(),
          // isDragged: oldData ? (oldData?.data?.isDragged || false) : false,
        }

        let details = {
          data,
          current: {
            Patient: localPatient,
            Facility: localFacility,
            Provider: localProvider,
            Insurance: Insurance,
          },
        }

        tempAppointments.push(details)
      } else {
        alert('Patient creation failed: Patient creation date not found. \n Hint: Try using manual-schedule to proceed.')
      }
    } catch (error) {
      console.error('Error fetching patient orders', error)
    }
    // Update appointments once at the end
    if (tempAppointments.length > 0) {
      setAppointments((prev) => {
        const allAppointments = [...prev, ...tempAppointments]
        handleSubmit(allAppointments)
        return allAppointments
      })
    }
  }

  useEffect(() => {
    if (showPatientAppointmentId) {
      GetSelectedPatientAppoint()
    }
  }, [showPatientAppointmentId])

  useEffect(() => {
    getProviders()
    getFacilitiesAppointment()
  }, [])

  const getSuperBillData = async (patientID) => {
    try {
      let data = await PatientSuperBillData('Get_By_PatientId', '', '', '', patientID.toString())
      data = JSON.parse(data?.d)?.Data || []

      if (data?.length) {
        data = data.map((item) => ({
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }))
      }

      setSuperBill(data)

      const lastItem = data?.at(-1)?.Data?.followUpTime ?? null

      setScheduleTime(lastItem)
      return lastItem
    } catch (error) {
      console.error('Error fetching Super Bill data:', error)
    }
  }

  // const getIntoNoteLatestHandle = async (patientID, patientData) => {
  //   const patientAppointments = appointment.filter((item) => item.current.Patient.value === patientData?.PatientID)
  //   const scheduledAppointment = patientAppointments.find((p) => {
  //     const status = p?.data?.Status
  //     const scheduleBy = p?.data?.ScheduleBy
  //     const type = p?.data?.Type
  //     const isInFacility = p?.data?.isInFacility
  //     const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
  //     let priorAuthTime = 0
  //     if (priorAuth) {
  //       priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
  //     }

  //     // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
  //     const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
  //     const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

  //     return isScheduledOrRescheduled && isManualOrFollowUp
  //   })
  //   const dataResponse = await PatientNoteDataCRUD('GET', patientID)
  //   const parsedData = JSON.parse(dataResponse?.d)?.Data
  //   if (parsedData?.length > 0 && patientAppointments?.length > 0) {
  //     setPatientID(patientData?.PatientID)
  //     setPatientIDClicked(patientData?.PatientID)
  //     setRowClicked(patientData)
  //     setPatientModalVisible(true)
  //     setPatientAppointmentID(scheduledAppointment?.data?.AppointmentID)
  //     const latestItem = parsedData[parsedData.length - 1]
  //     setEditDataId(latestItem?.id)
  //     setDataCallType('edit')
  //     setNoteStatus(parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
  //     setPatientModalVisible(false)
  //     setNoteID(parsedData.length - 1)
  //     setPatientData(patientData)
  //     noteStructureRef.current = JSON.parse(latestItem?.data)
  //   }
  // }
  const getIntoNoteLatestHandle = async (patientID, patientData) => {
    // const patientAppointments = appointment.filter((item) => item.current.Patient.value === patientData?.PatientID)

    const cachedNotesData = await getOpenChartAppointmentData()
    const parsedNotes = JSON.parse(cachedNotesData)

    const patientAppointments = parsedNotes.filter((item) => item.appointmentData?.PatientID === patientData?.PatientID)
    if (patientAppointments.length === 0) {
      toast.error('Some data in the system appears to be incomplete or outdated. Please click Refresh to update and continue.', toastConfig)
      return
    }

    const scheduledAppointment = patientAppointments.find((p) => {
      const status = p?.data?.Status
      const scheduleBy = p?.data?.ScheduleBy
      const type = p?.data?.Type
      const isInFacility = p?.data?.isInFacility
      const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
      let priorAuthTime = 0
      if (priorAuth) {
        priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
      }

      // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
      const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
      const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

      return isScheduledOrRescheduled && isManualOrFollowUp
    })

    const AppointmentID = patientAppointments[0]?.appointmentID
    // const dataResponse = await PatientNoteDataCRUD('GET', patientID)
    // const parsedData = JSON.parse(dataResponse?.d)?.Data

    const offlineData = await getOpenChartOfflineData()

    if (!offlineData || Object?.keys(offlineData).length === 0) {
      toast.error('Some data in the system appears to be incomplete or outdated. Please click Refresh to update and continue.', toastConfig)
    }
    const parsedData = offlineData[loggedUserProvider?.ID][patientID]?.allNotes || []
    if (parsedData.length === 0) {
      toast.error('Some data in the system appears to be incomplete or outdated. Please click Refresh to update and continue.', toastConfig)
    }
    if (parsedData?.length > 0 && patientAppointments?.length > 0) {
      // setPatientID(patientData?.PatientID)
      localStorage.setItem('setPatientIDLocal', patientData?.PatientID)
      // setPatientIDClicked(patientData?.PatientID)
      localStorage.setItem('setPatientIDClickedLocal', patientData?.PatientID)
      // setRowClicked(patientData)
      localStorage.setItem('setRowClickedLocal', JSON.stringify(patientData))
      // setPatientModalVisible(true)
      localStorage.setItem('setPatientModalVisibleLocal', true)
      // setPatientAppointmentID(scheduledAppointment?.data?.AppointmentID)
      localStorage.setItem('setPatientAppointmentIDLocal', AppointmentID)
      const latestItem = parsedData[parsedData.length - 1]
      // setEditDataId(latestItem?.id)
      localStorage.setItem('editDataIdLocal', latestItem?.id)
      // setDataCallType('edit')
      localStorage.setItem('dataCallTypeLocal', 'edit')
      // setNoteStatus(parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
      localStorage.setItem('noteStatusLocal', parsedData.length - 1 === 0 ? 'New Note' : 'Follow Up')
      // setPatientModalVisible(false)
      localStorage.setItem('patientModalVisibleLocal', false)
      // setNoteID(parsedData.length - 1)
      localStorage.setItem('noteIDLocal', parsedData.length - 1)
      // setPatientData(patientData)
      localStorage.setItem('patientDataLocal', JSON.stringify(patientData))
      noteStructureRef.current = JSON.parse(latestItem?.data)
      localStorage.setItem('noteStructureRefLocal', JSON.stringify(JSON.parse(latestItem?.data)))
      localStorage.setItem('openChartCall', 'OpenChart')
      window.open('/home/provider/appointment', '_blank', 'noopener,noreferrer')
    }
  }

  const safeParser = (data) => {
    try {
      return JSON.parse(data)
    } catch (e) {
      return data
    }
  }

  useEffect(() => {
    const setPatientIDLocal = safeParser(localStorage.getItem('setPatientIDLocal'))
    const setPatientIDClickedLocal = safeParser(localStorage.getItem('setPatientIDClickedLocal'))
    const setRowClickedLocal = safeParser(localStorage.getItem('setRowClickedLocal'))
    const setPatientModalVisibleLocal = safeParser(localStorage.getItem('setPatientModalVisibleLocal'))
    const setPatientAppointmentIDLocal = safeParser(localStorage.getItem('setPatientAppointmentIDLocal'))
    const editDataIdLocal = safeParser(localStorage.getItem('editDataIdLocal'))
    const dataCallTypeLocal = safeParser(localStorage.getItem('dataCallTypeLocal'))
    const noteStatusLocal = safeParser(localStorage.getItem('noteStatusLocal'))
    const patientModalVisibleLocal = safeParser(localStorage.getItem('patientModalVisibleLocal'))
    const noteIDLocal = safeParser(localStorage.getItem('noteIDLocal'))
    const patientDataLocal = safeParser(localStorage.getItem('patientDataLocal'))
    const noteStructureRefLocal = safeParser(localStorage.getItem('noteStructureRefLocal'))

    // if (setPatientIDLocal && setPatientIDLocal !== -1) {
    //     setPatientID(setPatientIDLocal)
    // }
    // if (setPatientIDClickedLocal && setPatientIDClickedLocal !== -1) {
    //     setPatientIDClicked(setPatientIDClickedLocal)
    // }
    // if (setRowClickedLocal !== null && setRowClickedLocal !== undefined) {
    //     setRowClicked(setRowClickedLocal)
    //     setPatientData(setRowClickedLocal)
    // }
    // if (setPatientModalVisibleLocal) {
    //     //   set(setPatientModalVisibleLocal)
    // }
    // if (setPatientAppointmentIDLocal) {
    //     setPatientAppointmentID(setPatientAppointmentIDLocal)
    // }
    if (editDataIdLocal) {
      setEditDataId(editDataIdLocal)
    }
    // if (dataCallTypeLocal) {
    //     setDataCallType(dataCallTypeLocal)
    // }
    // if (noteStatusLocal) {
    //     setNoteStatus(noteStatusLocal)
    // }
    // if (patientModalVisibleLocal) {
    //     // setPatientModalVisible(patientModalVisibleLocal)
    // }
    // if (noteIDLocal) {
    //     setNoteID(noteIDLocal)
    // }
    // if (patientDataLocal) {
    //     setPatientData(patientDataLocal)
    // }
    // if(noteStructureRefLocal !==  null && noteStructureRefLocal !== undefined){
    //     noteStructureRef.current = noteStructureRefLocal
    // }
  }, [])

  const userData = JSON.parse(localStorage.getItem('user'))

  const role = userData?.Role

  const [selectedPatientId, setSelectedPatientId] = useState(null)

  const [masterModel, setMasterModel] = useState(null)

  // useEffect(() => {
  //   let timer

  //   if (isRefreshLoad) {
  //     setAppointmentProgress(0)
  //     timer = setInterval(() => {
  //       setAppointmentProgress((prev) => {
  //         const next = prev + 3
  //         return next > 100 ? 100 : next
  //       })
  //     }, 60)
  //   }
  //   return () => clearInterval(timer)
  // }, [isRefreshLoad])

  const checkData = async () => {
    const hasData = await checkIfMastersExist()
    if (!hasData) {
      setMasterModel(true)
    }
  }

  const [yesterdayPatients, setYesterdayPatients] = useState([])

  const parseAppointmentDate = (startTime) => {
    if (!startTime) return null

    const [datePart] = startTime.split(' ')
    const [month, day, year] = datePart.split('/')

    return new Date(year, month - 1, day)
  }

  const getYesterdayDate = () => {
    const today = new Date()
    const yesterday = new Date(today)
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0)
    return yesterday
  }

  const filterYesterdayAppointments = (patients) => {
    const yesterday = getYesterdayDate()

    const filteredObject = Object.entries(patients).reduce((acc, [patientId, patientData]) => {
      const startTime = patientData?.appointmentData?.StartTime
      const appointmentDate = parseAppointmentDate(startTime)

      if (appointmentDate && appointmentDate.getTime() === yesterday.getTime()) {
        acc[patientId] = patientData
      }

      return acc
    }, {})

    return filteredObject
  }

  const getTodayKey = () => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return today.toISOString().split('T')[0]
  }

  const mergerTodaysAppointment = async (appointmentData) => {
    const todayKey = getTodayKey()
    const lastMergedDate = localStorage.getItem('lastOpenChartMerge')

    if (lastMergedDate === todayKey) {
      return false
    }

    localStorage.setItem('lastOpenChartMerge', todayKey)

    const data = await getOpenChartOfflineData()
    const loggedUser = await getProviderDetails()
    const loggedUserID = loggedUser?.ID

    const userData = data[loggedUserID] || {}

    const updatedUserData = {
      ...userData,
      ...appointmentData,
    }

    const updatedData = {
      ...data,
      [loggedUserID]: updatedUserData,
    }

    const patientDataArray = Object.values(appointmentData)
      .filter((item) => {
        const status = item?.newlyAddedData?.currentNote?.status

        if (status == 'Signed') {
          return false
        }

        return true
      })
      .map((item) => item.patientData)
      .filter(Boolean)

    const cachedNotesData = await getOpenChartAppointmentData()
    const parsedNotes = JSON.parse(cachedNotesData)

    const finalOpenChartAppointment = [...patientDataArray, ...parsedNotes]

    await saveOpenChartAppointmentData(JSON.stringify(finalOpenChartAppointment))
    await saveOpenChartOfflineData(updatedData)
    return true
  }

  const [refreshPage, setRefreshPage] = useState(false)
  const getTodaysAppointmentData = async () => {
    try {
      const getProviderDetailsData = await getProviderDetails()
      const data = await getOfflineData()
      const DBData = data[getProviderDetailsData?.ID] || {}

      const todaysAppointment = filterYesterdayAppointments(DBData)

      if (Object.keys(todaysAppointment).length > 0) {
        const isSuccess = await mergerTodaysAppointment(todaysAppointment)
        if (isSuccess) {
          setRefreshPage((prev) => !prev)
        }
      }
    } catch (error) {
      console.log(error, 'error data')
    } finally {
    }
  }

  const [addedNewIncident, setAddedNewIncident] = useState(false)
  useEffect(() => {
    checkData()
    getTodaysAppointmentData()
  }, [])
  return (
    <>
      <div className="" style={{ height: '100vh' }}>
        {showPatientInfo ? (
          <PatientInfoTodaysAppointments
            hpiAdded={hpiAdded}
            setHpiAdded={setHpiAdded}
            setAllAppointmentRawData={setAllAppointmentRawData}
            allAppointmentRawData={allAppointmentRawData}
            isAllotedToProvider={true}
            creatingNewNote={creatingNewNote}
            setCreatingNewNote={setCreatingNewNote}
            childformData={childformData}
            setChildFormData={setChildFormData}
            saveDiagnosisData={saveDiagnosisData}
            noteStatus={noteStatus}
            patientID={patientIDClicked}
            patientData={rowClicked}
            noteStructureRef={noteStructureRef}
            dataCallType={dataCallType}
            setEditDataId={setEditDataId}
            setDataCallType={setDataCallType}
            noteID={noteID}
            setDataId={setDataId}
            handleAddNoteId={handleAddNoteId}
            appointments={appointments}
            setAddedNewIncident={setAddedNewIncident}
          />
        ) : setDataId ? (
          <PatientInfoTodaysAppointments
            hpiAdded={hpiAdded}
            setHpiAdded={setHpiAdded}
            isAllotedToProvider={true}
            creatingNewNote={creatingNewNote}
            setCreatingNewNote={setCreatingNewNote}
            childformData={childformData}
            setChildFormData={setChildFormData}
            saveDiagnosisData={saveDiagnosisData}
            noteStatus={noteStatus}
            patientID={patientIDClicked}
            patientData={rowClicked}
            noteStructureRef={noteStructureRef}
            dataCallType={dataCallType}
            setDataId={setDataId}
            setDataCallType={setDataCallType}
            noteID={noteID}
            setEditDataId={setEditDataId}
            handleAddNoteId={handleAddNoteId}
            appointments={appointments}
            setAddedNewIncident={setAddedNewIncident}
          />
        ) : (
          <div className=" position-relative ">
            {/* <div className="d-flex justify-content-center gap-2 my-2">
              <button
                style={{
                  backgroundColor: `${activeKeyTab === 1 ? '#4363F2' : '#191919'}`,
                  border: '1px solid #333',
                  height: '40px',
                  padding: '5px 14px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  color: '#fff',
                  fontWeight: '500',
                  fontSize: '14px',
                  boxShadow: 'none',
                }}
                //   className={`btn ${activeKeyTab === 1 ? 'btn-primary' : 'btn-outline-secondary'}`}
                onClick={() => setActiveKeyTab(1)}
              >
                Scheduled
              </button>
              <button
                style={{
                  backgroundColor: `${activeKeyTab === 2 ? '#4363F2' : '#191919'}`,
                  border: '1px solid #333',
                  height: '40px',
                  padding: '5px 14px',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  color: '#fff',
                  fontWeight: '500',
                  fontSize: '14px',
                  boxShadow: 'none',
                }}
                className={`btn ${activeKeyTab === 2 ? 'btn-primary' : 'btn-outline-secondary'}`}
                onClick={() => setActiveKeyTab(2)}
              >
                Upload
              </button>
            </div> */}
            <div className="mt-1">
              <CTabContent className="  border-top-0 rounded-bottom">
                <CTabPane visible={activeKeyTab === 1}>
                  <div className="patient-page-wrapper page-wrapper">
                    <div className="page-header">
                      <div className="d-flex align-items-center gap-2 justify-content-center dark-search">
                        {/* <div className={` search-input ${role == 'provider' ? 'search-dark' : ''}`}>
                    <div className="">
                      <SearchIcon className="" />
                    </div>
                    <div>
                      <input
                        className="input-field-provider-page"
                        onChange={(e) => {
                          setFilterData({ ...filterData, searchValue: e.target.value })
                        }}
                        type="text"
                        placeholder="Search by Patient..."
                      />
                    </div>
                  </div> */}

                        <div className="" style={{ position: 'relative', display: 'flex', alignItems: 'center', marginLeft: '', display: 'flex', gap: '10px' }}>
                          {/* <CFormLabel>Select Scheduled Date</CFormLabel> */}
                          {/* <div>
                      <CustomDatePickingFormat
                        value={filterData.scheduleDate || ''}
                        aria-describedby="exampleFormControlInputHelpInline"
                        onChange={(e) => {
                          setFilterData((p) => ({
                            ...p,
                            scheduleDate: e, // Keep the date in "YYYY-MM-DD" format
                          }))
                        }}
                      />
                    </div> */}

                          <div className="  ">
                            {/* <Button
                        className="d-flex align-items-center gap-2"
                        style={{
                          backgroundColor: '#4363F2',
                          border: '1px solid #333',
                          height: '40px',
                          padding: '5px 14px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px',
                          color: '#fff',
                          fontWeight: '500',
                          fontSize: '14px',
                          boxShadow: 'none',
                        }}
                        variant="outlined"
                        size="large"
                        onClick={() => setShowFilter(!showFilter)}
                      >
                        <FunnelPlotOutlined />
                        Filter
                      </Button>

                      {showFilter && (
                        <motion.div
                          initial={{ opacity: 0, y: 4 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: 4 }}
                          transition={{ duration: 0.3, ease: 'easeInOut' }}
                          style={{
                            width: '300px',
                            zIndex: 50,
                            backgroundColor: '#282828',
                            borderRadius: '10px',
                          }}
                          className="position-absolute gap-1 d-flex flex-column top-full left-0 z-10   shadow-lg p-4 rounded-md"
                        >
                          <div>
                            <CFormLabel>Facility</CFormLabel>
                            <Select
                              placeholder="Select"
                              name="facility"
                              options={facilities}
                              value={facilities.filter((fac) => filterData.facility.includes(fac.value))}
                              isMulti
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: '#191919',
                                  borderColor: state.isFocused ? '#444' : '#444',
                                  borderRadius: '6px',
                                  boxShadow: 'none',
                                  '&:hover': {
                                    borderColor: '#444',
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  backgroundColor: '#000',
                                  borderRadius: '6px',
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? '#191919' // blue for selected
                                    : state.isFocused
                                    ? '#2a2a2a'
                                    : '#000',
                                  color: 'white',
                                  cursor: 'pointer',
                                  padding: '12px 14px',
                                  borderBottom: '1px solid #333',
                                  ':last-of-type': {
                                    borderBottom: 'none',
                                  },
                                  ':active': {
                                    backgroundColor: '#2a2a2a',
                                  },
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: '#191919',
                                  borderRadius: '4px',
                                  border: '1px solid #454545ff',
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: 'white',
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: 'white',
                                  ':hover': {
                                    backgroundColor: '#333',
                                    color: 'white',
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: 'white',
                                }),
                                placeholder: (base) => ({
                                  ...base,
                                  color: '#aaa',
                                }),

                                input: (base) => ({
                                  ...base,
                                  color: 'white',
                                }),
                                dropdownIndicator: (base) => ({
                                  ...base,
                                  color: 'white',
                                  ':hover': { color: 'white' },
                                }),
                              }}
                              isClearable
                              onChange={(selectedOptions) =>
                                setFilterData((prev) => ({
                                  ...prev,
                                  facility: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                }))
                              }
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          </div>

                          <div className="mt-2">
                            <CFormLabel>Patient Status</CFormLabel>
                            <Select
                              name="status"
                              isMulti
                              placeholder="Select"
                              styles={{
                                control: (base, state) => ({
                                  ...base,
                                  backgroundColor: '#191919',
                                  borderColor: state.isFocused ? '#444' : '#444',
                                  borderRadius: '6px',
                                  boxShadow: 'none',
                                  '&:hover': {
                                    borderColor: '#444',
                                  },
                                }),
                                menu: (base) => ({
                                  ...base,
                                  backgroundColor: '#000',
                                  borderRadius: '6px',
                                }),
                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isSelected
                                    ? '#191919' // blue for selected
                                    : state.isFocused
                                    ? '#2a2a2a'
                                    : '#000',
                                  color: 'white',
                                  cursor: 'pointer',
                                  padding: '12px 14px',
                                  borderBottom: '1px solid #333',
                                  ':last-of-type': {
                                    borderBottom: 'none',
                                  },
                                  ':active': {
                                    backgroundColor: '#2a2a2a',
                                  },
                                }),
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: '#191919',
                                  borderRadius: '4px',
                                  border: '1px solid #454545ff',
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: 'white',
                                }),
                                multiValueRemove: (base) => ({
                                  ...base,
                                  color: 'white',
                                  ':hover': {
                                    backgroundColor: '#333',
                                    color: 'white',
                                  },
                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: 'white',
                                }),
                                placeholder: (base) => ({
                                  ...base,
                                  color: '#aaa',
                                }),

                                input: (base) => ({
                                  ...base,
                                  color: 'white',
                                }),
                                dropdownIndicator: (base) => ({
                                  ...base,
                                  color: 'white',
                                  ':hover': { color: 'white' },
                                }),
                              }}
                              options={selectStatusOption}
                              isClearable
                              value={selectStatusOption.filter((option) => filterData.status.includes(option.value))}
                              onChange={(selectedOptions) =>
                                setFilterData((prev) => ({
                                  ...prev,
                                  status: selectedOptions ? selectedOptions.map((option) => option.value) : [],
                                }))
                              }
                              classNamePrefix="select"
                            />
                          </div>

                          <div className="mt-2" style={{ position: 'relative', display: 'inline-block' }}>
                            <CFormLabel>DOB</CFormLabel>
                            <div>
                              <CustomDatePickingFormat
                                value={filterData.date || ''}
                                aria-describedby="exampleFormControlInputHelpInline"
                                onChange={(e) => {
                                  setFilterData((p) => ({
                                    ...p,
                                    date: e, // Keep the date in "YYYY-MM-DD" format
                                  }))
                                }}
                              />
                            </div>
                          </div>

                          <Button
                            style={{
                              backgroundColor: '#4363F2',
                              border: '1px solid #333',
                              height: '40px',
                              padding: '5px 14px',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              color: '#fff',
                              fontWeight: '500',
                              fontSize: '14px',
                              boxShadow: 'none',
                            }}
                            className="mt-2"
                            onClick={() => setShowFilter(false)}
                            variant="outlined"
                          >
                            Close
                          </Button>
                        </motion.div>
                      )} */}
                          </div>
                          <div
                            style={{
                              backgroundColor: 'inherit',
                              border: `1px solid ${!isRrefreshedToday ? '#ff0000' : '#333'}`,
                              height: '40px',
                              padding: '5px 14px',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              color: '#fff',
                              fontWeight: '500',
                              fontSize: '14px',
                              boxShadow: 'none',
                              cursor: 'pointer',
                            }}
                            // onClick={() => {
                            //   getAppointmentData(), downLoadTodaysPatient()
                            // }}
                            onClick={() => {
                              downLoadTodaysPatient()
                            }}
                          >
                            <CTooltip content={'Refresh Data'}>
                              <CTooltip content="Refresh Data">{isRefreshLoad ? <Download size={18} /> : <Download size={18} />}</CTooltip>
                            </CTooltip>
                            Refresh Open Chartssss
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="mx-3 d-flex align-items-center gap-2">
                          <div className="display-total-patient">
                            <span className="mx-1">{patientInfoCount?.newPatient || 0}</span> NP
                          </div>
                          <div className="display-total-patient">
                            <span className="mx-1">{patientInfoCount?.followUp || 0}</span> FU
                          </div>
                          <div className="display-total-patient mr-">
                            <span className="mx-1">{patientCount}</span> Patients
                          </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-2 ">
                          {/* <CButton
                    onClick={() => {
                      setBoxView('list')
                    }}
                    style={{
                      backgroundColor: boxView === 'list' ? '#4363F2' : '#0E0E0E',
                      border: '1px solid #333',
                      height: '40px',
                      padding: '5px 14px',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      color: '#fff',
                      fontWeight: '500',
                      fontSize: '14px',
                      boxShadow: 'none',
                    }}
                    className=" d-flex align-items-center justify-content-center"
                  >
                    <AlignLeft size={16} strokeWidth={1.25} />
                    <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500', color: 'white' }}>List</div>
                  </CButton> */}
                          {/* <CButton
                    onClick={() => {
                      setBoxView('table')
                    }}
                    style={{
                      backgroundColor: boxView === 'table' ? '#4363F2' : '#0E0E0E',
                      border: '1px solid #333',
                      height: '40px',
                      padding: '5px 14px',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      color: '#fff',
                      fontWeight: '500',
                      fontSize: '14px',
                      boxShadow: 'none',
                    }}
                    disabled
                    className=" d-flex align-items-center justify-content-center"
                  >
                    <Table2 size={16} strokeWidth={1.25} />
                    <div style={{ marginLeft: '8px', fontSize: '14px', fontWeight: '500' }}>Details</div>
                  </CButton> */}
                        </div>
                      </div>
                    </div>

                    {boxView === 'table' && (
                      <div className="custom-card-wrapper dark-patient-section" style={{ padding: '0px 0px 0px 0px', marginTop: '20px' }}>
                        {updatedFilteredPatients.length > 0 &&
                          updatedFilteredPatients.map((patient, index) => {
                            // let provider = appointment.filter(item => item.current.Patient.value === patient.PatientID);
                            const patientAppointments = appointment.filter((item) => item.current.Patient.value === patient.PatientID)

                            // let providerName = provider[0]?.current?.Provider?.label;
                            // let scheduleDate = provider[0]?.data?.StartTime
                            // scheduleDate = scheduleDate?.split(" ")

                            const scheduledAppointment = patientAppointments.find((p) => {
                              const status = p?.data?.Status
                              const scheduleBy = p?.data?.ScheduleBy
                              const type = p?.data?.Type
                              const isInFacility = p?.data?.isInFacility
                              const priorAuth = p?.data?.otherDetails?.priorAuth?.isRequired
                              let priorAuthTime = 0
                              if (priorAuth) {
                                priorAuthTime = parseInt(p?.data?.otherDetails?.priorAuth?.details?.noOfTimes, 10)
                              }

                              // const isManualOrFollowUp = scheduleBy !== 'auto' || type === 'Follow Up';
                              const isManualOrFollowUp = scheduleBy !== 'auto' || (type === 'Follow Up' && isInFacility && priorAuth && priorAuthTime > 0)
                              const isScheduledOrRescheduled = status === 'Scheduled' || status === 'Rescheduled'

                              return isScheduledOrRescheduled && isManualOrFollowUp
                            })

                            if (!scheduledAppointment) return null

                            const providerName = scheduledAppointment?.current?.Provider?.label
                            const scheduleDate = scheduledAppointment?.data?.StartTime?.split(' ')[0]
                            const Type = scheduledAppointment?.data?.Type

                            const isProviderAppointment = providerName === loggedUserProvider?.Name

                            if (!isProviderAppointment) return null
                            return (
                              <div key={index} className="custom-card" style={{ background: '' }}>
                                <div className="card-header">
                                  <div>
                                    <div className="d-flex align-items-center gap-2">
                                      <p className="name-block">
                                        {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                                        <span
                                          style={{
                                            color: Type === 'New' ? 'green' : Type === 'Follow Up' ? 'orange' : 'skyblue',
                                            fontWeight: 'bold',
                                            fontSize: '0.6em',
                                          }}
                                        >
                                          ({Type === 'Follow Up' ? 'Follow Up' : Type === 'New' ? 'New Patient' : Type === 'Re Admit' ? 'Re Admit' : ''})
                                        </span>
                                      </p>
                                    </div>
                                    <div className="bullet-points">
                                      <span>{patient.Gender}</span>
                                      <span>
                                        DOB:{' '}
                                        {new Date(patient?.DOB).toLocaleDateString('en-US', {
                                          month: '2-digit',
                                          day: '2-digit',
                                          year: 'numeric',
                                        })}
                                      </span>
                                      <span>{patient.Age} Years</span>
                                    </div>
                                  </div>
                                  <div className="button-wrapper">
                                    {/* <a href="/home/scheduler"><CButton variant='outline' color='warning' className="px-2"><HiPencil size={20} /></CButton></a>
                                                        <CButton onClick={() => setShowPatientAppointmentId(patient?.PatientID)} variant='outline' color='success' className="px-2"><HiEye size={20} /></CButton>
                                                        <CButton onClick={() => openTreatmentNote(patient, scheduledAppointment?.data?.AppointmentID)} variant='outline' color='dark' className="px-2"><ExitToAppIcon size={20} /></CButton>
                                                        <CDropdown>
                                                            <CDropdownToggle
                                                                style={{
                                                                    padding: 0,
                                                                    margin: 0
                                                                }}
                                                                color="">
                                                                <CButton variant='outline' color='dark' className="calendar-button px-2"><CalendarCheck size={20} /></CButton>
                                                            </CDropdownToggle>
                                                            <CDropdownMenu>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'cancel', patient?.PatientID, patient)}>Cancel</CDropdownItem>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'finish', patient?.PatientID, patient)}>Finish</CDropdownItem>
                                                                <CDropdownItem onClick={() => handleAppointment(scheduledAppointment?.data?.AppointmentID, 'delete', patient?.PatientID, patient)}>Delete</CDropdownItem>

                                                            </CDropdownMenu>
                                                        </CDropdown> */}
                                    <CButton
                                      onClick={() => {
                                        // setPatientData(patient)
                                        getIntoNoteLatestHandle(patient?.PatientID, patient)
                                      }}
                                      variant="outline"
                                      color="dark"
                                      className="px-2 border-0"
                                    >
                                      <FilePenLine size={20} />
                                    </CButton>
                                  </div>
                                </div>
                                <div className="contact-wrapper w-100  d-flex  px-3">
                                  <div>
                                    <p className="title">Provider Name</p>
                                    <p className="value">{providerName}</p>
                                  </div>
                                  <div>
                                    <p className="title">Schedule Date</p>
                                    <p className="value">{scheduleDate}</p>
                                  </div>
                                  <div>
                                    <p className="title">Note Status</p>
                                    <p className="value">{patient?.noteStatus === 'Draft' && patient.noteFlag === 'true' ? 'Provider Draft' : patient?.noteStatus}</p>
                                  </div>
                                </div>
                                <div className="card-footer w-100 d-flex justify-content- align-items-start">
                                  <div className="facility mw-100">
                                    <p className="title">FACILITY NAME</p>
                                    <p className="value">
                                      {patient.FacilityName}
                                      {patient.facilityParentCompany && ` - ${patient.facilityParentCompany}`}
                                    </p>
                                  </div>
                                  <div className="room-count">
                                    <p className="title">ROOM</p>
                                    <p className="value">{patient.Room ?? ''}</p>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                      </div>
                    )}
                    {boxView === 'list' && (
                      <div className="hierachy-list-view d-flex flex-column gap-2" style={{ marginTop: '20px' }}>
                        <CAccordion
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '15px',
                            // background:"#fff",
                            // borderRadius:"12px"
                          }}
                          className="border-bottom-0 border-0 p-0 m-0"
                          alwaysOpen
                        >
                          {Object.entries(groupedUpdatedFilteredPatients).map(([date, facilities], dateIdx) => {
                            const totalPatientsForDate = Object.values(facilities).reduce((sum, patients) => sum + patients.length, 0)
                            return (
                              <div className="testdiv provider-page " style={{ width: '' }}>
                                <div className="border-bottom-0 border-0 w-100" itemKey={`date-${dateIdx}`} key={date}>
                                  <div className="border-bottom-0 border-0">
                                    {date} - ({totalPatientsForDate})
                                  </div>

                                  <div className={`accordion-wrapper border-bottom-0 border-0 p-0 shadow-sm ${role == 'provider' ? 'accordion-dark' : 'accordion-light'}`} style={{ borderRadius: '40px!important' }}>
                                    <CAccordion alwaysOpen className="border-bottom-0 border-0 p-0 homeAccordion ">
                                      {Object.entries(facilities).map(([facility, patients], facIdx) => {
                                        const parentCompanyName = patients.find((patient) => patient?.facilityParentCompany)?.facilityParentCompany || ''

                                        return (
                                          <CAccordionItem className="border-bottom-0 border-0 mt-2" itemKey={`fac-${dateIdx}-${facIdx}`} key={facility}>
                                            <CAccordionHeader className="border-bottom-0 border-0 px-3 py-1 m-0 my-2  " style={{ fontSize: '14px', boxShadow: 'unset' }}>
                                              <div className="d-flex align-items-center gap-2 flex-wrap w-100">
                                                <span>
                                                  {facility} - ({patients?.length}) {parentCompanyName && `- ${parentCompanyName}`}
                                                </span>
                                              </div>
                                            </CAccordionHeader>

                                            <CAccordionBody className=" mx-3 ">
                                              <CTable responsive className=" mb-3 border-bottom-0 border-0  ">
                                                <CTableBody className="">
                                                  {patients.length > 0 &&
                                                    patients.map((patient, index) => (
                                                      <CTableRow
                                                        className="order-0 patient-row-shadow"
                                                        //   className={`order-0 px-4 ${patient.Status === 'NewPatient' ? "NP" : patient.Status === 'Follow Up' ? "FU" : patient.Status} patient-row-list`}
                                                        key={patient.PatientID}
                                                        onClick={async () => {
                                                          setSelectedPatientId(patient.PatientID)
                                                          await getIntoNoteLatestHandle(patient?.PatientID, patient)

                                                          setTimeout(() => {
                                                            setSelectedPatientId(null)
                                                          }, 10000)
                                                        }}
                                                        style={{
                                                          cursor: 'pointer',
                                                          verticalAlign: 'middle',
                                                          gap: '20px',
                                                          margin: '10px 2px',
                                                          background: '#1E1E1E',
                                                          boxShadow: selectedPatientId === patient.PatientID ? '0 0 10px #ffffff' : '0 0 4px rgba(0, 0, 0, 0.5)',
                                                          borderRadius: '6px',
                                                          transition: 'all 0.25s ease-in-out',
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          if (selectedPatientId !== patient.PatientID) {
                                                            e.currentTarget.style.boxShadow = '0 0 8px rgba(255,255,255,0.2)'
                                                          }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          if (selectedPatientId !== patient.PatientID) {
                                                            e.currentTarget.style.boxShadow = '0 0 4px rgba(0, 0, 0, 0.5)'
                                                          }
                                                        }}
                                                      >
                                                        <CTableDataCell className="border-bottom-0 border-0 p-0" scope="row">
                                                          <span className="patient-name-fixed d-flex align-items-center gap-2 text-white" style={{ fontWeight: '100' }}>
                                                            <span
                                                              style={{
                                                                width: '10px',
                                                                height: '10px',
                                                                background: patient?.Status === 'NewPatient' ? 'green' : patient?.Status === 'Follow Up' ? 'orange' : 'gray',
                                                                display: 'block',
                                                                borderRadius: '50px',
                                                              }}
                                                            ></span>
                                                            {patient.FirstName + ' ' + patient.MiddleName + ' ' + patient.LastName}
                                                          </span>
                                                        </CTableDataCell>
                                                        <CTableDataCell className="d-flex align-items-center justify-content-end border-bottom-0 border-0">
                                                          <span className="room-pill"> Room : {patient?.Room}</span>
                                                          {/* <span className="notestatus-pill"> {patient?.Status === 'NewPatient' ? 'New Patient' : patient?.Status}</span> */}
                                                          {patient?.patientSeen === false && <span className="schedule1-pill">Not Seen : {patient?.notSeenReason}</span>}
                                                          {/* <CButton
                                                  className="border-0"
                                                  variant="outline"
                                                  style={{ fontSize: '14px', color: 'white' }}
                                                  onClick={() => {
                                                    getIntoNoteLatestHandle(patient?.PatientID, patient)
                                                  }}
                                                >
                                                  <FilePenLine />
                                                </CButton> */}
                                                        </CTableDataCell>
                                                      </CTableRow>
                                                    ))}
                                                </CTableBody>
                                              </CTable>
                                            </CAccordionBody>
                                          </CAccordionItem>
                                        )
                                      })}
                                    </CAccordion>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                          {Object.keys(groupedUpdatedFilteredPatients).length === 0 && (
                            <div className="d-flex justify-content-center align-items-start text-muted">
                              <div
                                style={{
                                  padding: '40px',
                                  fontSize: '15px',
                                  fontWeight: '600px',
                                  color: 'gray',
                                }}
                              >
                                Click on "Refresh Open Charts" to get the data
                              </div>
                            </div>
                          )}
                        </CAccordion>
                      </div>
                    )}

                    {/* <CustomAgGrid callFrom="Patient" rowClickedFn={patientSelected} options={patientData} btnList={buttonList}></CustomAgGrid> */}

                    <CModal size="lg" visible={patientModelVisible} onClose={() => setPatientModalVisible(false)}>
                      {/* patientData, patientID, setPatientModalVisible, setDataCallType, setShowPatientInfo, setEditDataId, setNoteID, patientSelected, childformData, setChildFormData, saveDiagnosisData */}
                      <CModalBody className="view-data-modal" style={{ padding: '2rem', borderRadius: '2rem', overflow: 'auto' }}>
                        {
                          <PatientPopup
                            creatingNewNote={creatingNewNote}
                            setCreatingNewNote={setCreatingNewNote}
                            noteStatus={noteStatus}
                            setNoteStatus={setNoteStatus}
                            patientSelected={patientSelected}
                            setNoteID={setNoteID}
                            childformData={childformData}
                            setChildFormData={setChildFormData}
                            saveDiagnosisData={saveDiagnosisData}
                            patientID={patientIDClicked}
                            patientData={rowClicked}
                            noteStructureRef={noteStructureRef}
                            setPatientModalVisible={setPatientModalVisible}
                            dataCallType={dataCallType}
                            setDataCallType={setDataCallType}
                            setEditDataId={setEditDataId}
                            setShowPatientInfo={setShowPatientInfo}
                            setAllSelectedDiagnosis={setAllSelectedDiagnosis}
                            patientAppointmentID={patientAppointmentID}
                            appointment={appointment}
                            viewPatientDetail={viewPatientDetail}
                            handleAddNoteId={handleAddNoteId}
                            showViewIcon={true}
                          />
                        }
                      </CModalBody>
                      <CModalFooter>
                        <Button variant="outlined" onClick={() => setPatientModalVisible(false)}>
                          Close
                        </Button>
                      </CModalFooter>
                    </CModal>

                    <CModal visible={deleteVisible} onClose={() => setDeleteVisible(false)}>
                      <CModalHeader>
                        <CModalTitle>Warning</CModalTitle>
                      </CModalHeader>
                      <CModalBody>
                        <p>Are you sure you want to delete?</p>
                      </CModalBody>

                      <CModalFooter>
                        <CButton
                          onClick={() => {
                            setDeleteVisible(false)
                          }}
                          className="text-white"
                          color="secondary"
                        >
                          Close
                        </CButton>
                        <CButton onClick={handleDeletePatient} className="text-white" color="danger">
                          Delete
                        </CButton>
                      </CModalFooter>
                    </CModal>

                    <CModal
                      className="rounded"
                      alignment="center"
                      onClose={() => {
                        setShowPatientAppointmentId(null)
                      }}
                      visible={showPatientAppointmentId !== null}
                      aria-labelledby="VerticallyCenteredExample"
                    >
                      <CModalHeader>
                        <CModalTitle className="" style={{ fontSize: '20px!important' }} id="VerticallyCenteredExample">
                          Appointment Details
                        </CModalTitle>
                      </CModalHeader>
                      <CModalBody className="w-100">
                        <CNav className="d-flex align-items-center justify-content-center w-100" variant="pills" role="tablist">
                          <CNavItem>
                            <CNavLink active={activeKey === 2} onClick={() => setActiveKey(2)}>
                              Insurances
                            </CNavLink>
                          </CNavItem>
                          <CNavItem className="">
                            <CNavLink active={activeKey === 1} onClick={() => setActiveKey(1)}>
                              Other Details
                            </CNavLink>
                          </CNavItem>
                        </CNav>
                        <CTabContent>
                          <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeKey === 1}>
                            <div style={{ widht: '100%!important' }} className="d-flex py-2 w-100 align-items-center gap-4 justify-content-between flex-wrap w-full">
                              {patientAppointment.length > 0 ? (
                                <div>
                                  {patientAppointment
                                    .filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')
                                    .map((item, idx) => {
                                      return (
                                        <div key={idx} className="w-100">
                                          <div
                                            style={{
                                              display: 'grid!important',
                                              gridTemplateColumns: '1fr 1fr 1fr',
                                              gridGap: '10px',
                                            }}
                                            className="w-100"
                                          >
                                            <div className="d-flex gap-2">
                                              <p className="title fw-bold">Prior Auth Number: </p>
                                              <p className="fw-light">{item?.data?.otherDetails?.priorAuth?.details?.priorAuthNo ?? ''}</p>
                                            </div>
                                            <div className="d-flex gap-2">
                                              <p className="title fw-bold">Number of times: </p>
                                              <p className="fw-light">{item?.data?.otherDetails?.priorAuth?.details?.noOfTimes ?? ''}</p>
                                            </div>
                                            <div className="d-flex gap-2">
                                              <p className="title fw-bold">Expiry Date: </p>
                                              <p className="fw-light">{item?.data?.otherDetails?.priorAuth?.details?.expDate ?? ''}</p>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })}
                                </div>
                              ) : (
                                <div>
                                  <div className="w-100">
                                    <div
                                      style={{
                                        display: 'grid!important',
                                        gridTemplateColumns: '1fr 1fr 1fr',
                                        gridGap: '10px',
                                      }}
                                      className="w-100"
                                    >
                                      <div className="d-flex gap-2">
                                        <p className="title fw-bold">Prior Auth Number: </p>
                                        <p className="fw-light">{''}</p>
                                      </div>
                                      <div className="d-flex gap-2">
                                        <p className="title fw-bold">Number of times: </p>
                                        <p className="fw-light">{''}</p>
                                      </div>
                                      <div className="d-flex gap-2">
                                        <p className="title fw-bold">Expiry Date: </p>
                                        <p className="fw-light">{''}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </CTabPane>
                          <CTabPane role="tabpanel" aria-labelledby="home-tab" visible={activeKey === 2}>
                            <div style={{ widht: '100%!important' }} className="d-flex py-2 w-100 align-items-center gap-4 justify-content-between flex-wrap w-full">
                              {patientAppointment.length > 0 ? (
                                <div>
                                  {patientAppointment
                                    .filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')
                                    .map((item, idx) => {
                                      return (
                                        <div key={idx} className="w-100">
                                          <div
                                            style={{
                                              display: 'grid!important',
                                              gridTemplateColumns: '1fr 1fr 1fr',
                                              gridGap: '10px',
                                            }}
                                            className="w-100"
                                          >
                                            <div className="d-flex gap-2">
                                              <p className="title fw-bold">Insurance Type</p>
                                              <p className="fw-light">{item?.data?.Insurance?.Type ?? ''}</p>
                                            </div>
                                            <div className="d-flex gap-2">
                                              <p className="title fw-bold">Insurance Sub Type</p>
                                              <p className="fw-light">{item?.data?.Insurance?.SubType ?? ''}</p>
                                            </div>
                                            <div className="d-flex gap-2">
                                              <p className="title fw-bold">Policy Number: </p>
                                              <p className="fw-light">{item?.data?.Insurance?.PolicyNumber ?? ''}</p>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    })}
                                </div>
                              ) : (
                                <div>
                                  <div className="w-100">
                                    <div
                                      style={{
                                        display: 'grid!important',
                                        gridTemplateColumns: '1fr 1fr 1fr',
                                        gridGap: '10px',
                                      }}
                                      className="w-100"
                                    >
                                      <div className="d-flex gap-2">
                                        <p className="title fw-bold">Policy Number: </p>
                                        <p className="fw-light">{''}</p>
                                      </div>
                                      <div className="d-flex gap-2">
                                        <p className="title fw-bold">Insurance Type</p>
                                        <p className="fw-light">{''}</p>
                                      </div>
                                      <div className="d-flex gap-2">
                                        <p className="title fw-bold">Insurance Sub Type</p>
                                        <p className="fw-light">{''}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </CTabPane>
                        </CTabContent>
                      </CModalBody>
                    </CModal>

                    <CModal visible={cancelModel} onClose={() => setCancelModel(false)}>
                      <CModalHeader>
                        <CModalTitle>Cancel Appointment</CModalTitle>
                      </CModalHeader>

                      <CModalBody>
                        <div className="mt-4 p-4 rounded-4 shadow-sm border position-relative" style={{ backgroundColor: '#f8f9fa', borderLeft: '5px solid #dc3545' }}>
                          <div className="d-flex align-items-center mb-3">
                            <h6 className="mb-0 fw-bold text-dark">Cancellation Reason </h6>
                          </div>

                          <CFormTextarea
                            id="cancelReason"
                            value={cancelReason}
                            onChange={(e) => setCancelReason(e.target.value)}
                            placeholder="Type your cancellation reason here..."
                            className="rounded-3 shadow-sm border-0"
                            style={{
                              height: '140px',
                              padding: '1rem',
                              fontSize: '1rem',
                              backgroundColor: '#ffffff',
                              // resize: 'none',
                            }}
                          />
                        </div>
                      </CModalBody>

                      <CModalFooter>
                        <CButton onClick={() => setCancelModel(false)} className="text-white" color="secondary">
                          Close
                        </CButton>
                        <CButton onClick={() => handleAppointmentCancel('Canceled')} className="text-white" color="danger">
                          Proceed to Cancel
                        </CButton>
                      </CModalFooter>
                    </CModal>

                    <CModal visible={finishModel} onClose={() => setFinishModel(false)}>
                      <CModalHeader>
                        <CModalTitle>Finish Appointment</CModalTitle>
                      </CModalHeader>
                      <CModalBody>
                        <p>Are you sure you want to finish this appointment?</p>
                      </CModalBody>

                      <CModalFooter>
                        <CButton
                          onClick={() => {
                            setFinishModel(false)
                          }}
                          className="text-white"
                          color="secondary"
                        >
                          Close
                        </CButton>
                        <CButton
                          onClick={() => {
                            handleAppointmentSubmit('Finish')
                          }}
                          className="text-white"
                          color="success"
                        >
                          Finish Appointment
                        </CButton>
                      </CModalFooter>
                    </CModal>

                    <CModal visible={deleteModel} onClose={() => setDeleteModel(false)}>
                      <CModalHeader>
                        <CModalTitle>Delete Appointment</CModalTitle>
                      </CModalHeader>
                      <CModalBody>
                        <p>Are you sure you want to Delete this appointment?</p>
                      </CModalBody>

                      <CModalFooter>
                        <CButton
                          color="secondary"
                          variant="outline"
                          onClick={() => {
                            setDeleteModel(false)
                          }}
                        >
                          Cancel
                        </CButton>
                        <CButton
                          color="danger"
                          className="hrm-modal-danger-btn"
                          onClick={() => {
                            handleDeleteSubmit()
                          }}
                        >
                          Delete
                        </CButton>
                      </CModalFooter>
                    </CModal>

                    <CModal visible={masterModel} onClose={() => setMasterModel(false)}>
                      <CModalHeader
                        style={{
                          backgroundColor: '#191919',
                          borderBottom: '1px solid gray',
                          color: 'white',
                          display: 'flex',
                          justifyContent: 'center',
                          borderRadius: '10px 10px 0 0',
                        }}
                      >
                        <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Download Master</CModalTitle>
                      </CModalHeader>
                      <CModalBody
                        style={{
                          backgroundColor: '#191919',
                          color: 'white',
                        }}
                      >
                        <p>Please download master before continuing .</p>
                      </CModalBody>

                      <CModalFooter
                        style={{
                          backgroundColor: '#191919',
                          borderTop: '1px solid gray',
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '10px',
                          padding: '10px',
                          borderRadius: '0 0 10px 10px',
                        }}
                      >
                        <CButton
                          onClick={() => {
                            setMasterModel(false)
                          }}
                          style={{
                            backgroundColor: '#4363F2',
                            border: 'none',
                            color: 'white',
                            borderRadius: '6px',
                            padding: '8px 20px',
                          }}
                          variant="outline"
                        >
                          Close
                        </CButton>
                      </CModalFooter>
                    </CModal>
                  </div>
                </CTabPane>
                <CTabPane visible={activeKeyTab === 2}>
                  <UploadOpenChartPatient refreshPage={refreshPage} />
                </CTabPane>
              </CTabContent>
            </div>

            <CModal backdrop="static" size="lg" alignment="center" visible={isRefreshLoad} onClose={() => setIsRefreshLoad(false)}>
              <CModalBody style={{ backgroundColor: '#191919', color: 'white' }}>
                <div className="text-center ">
                  <div className="d-flex align-items-center justify-content-center mb-3">
                    <CAvatar src={logo} className="rounded-0" style={{ width: '90px', height: '90px' }} />
                    <span style={{ color: '#4FC3F7', fontSize: '18px', marginLeft: '1px' }}>Provio Solutions</span>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', padding: '20px' }}>
                    <div style={{ width: '60%' }}>
                      {' '}
                      <CProgress className="w-100" height={5}>
                        <CProgressBar value={appointmentProgress} color="info" animated />
                      </CProgress>
                      <p style={{ marginTop: '5px', color: '#aaa', fontSize: '14px', textAlign: 'center' }}>Downloading Patients - {Math.round(appointmentProgress)}%</p>
                    </div>
                  </div>
                </div>
              </CModalBody>

              <CModalFooter
                style={{
                  backgroundColor: '#191919',
                  borderTop: '1px solid gray',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                  padding: '10px',
                  borderRadius: '0 0 10px 10px',
                }}
              >
                <CButton onClick={() => setIsRefreshLoad(false)} style={{ backgroundColor: '#4363F2', border: 'none', color: 'white', borderRadius: '6px', padding: '8px 20px' }} variant="outline">
                  Cancel
                </CButton>
              </CModalFooter>
            </CModal>

            <CModal visible={showOverwriteModal} onClose={() => setShowOverwriteModal(false)} backdrop="static">
              <CModalHeader
                style={{
                  backgroundColor: '#191919',
                  borderBottom: '1px solid gray',
                  color: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  borderRadius: '10px 10px 0 0',
                }}
              >
                <CModalTitle style={{ color: 'white', width: '100%', textAlign: 'center' }}>Warning </CModalTitle>
              </CModalHeader>

              <CModalBody
                style={{
                  backgroundColor: '#191919',
                  color: 'white',
                }}
              >
                You have unsaved local changes. If you continue the download without pre-signing the following patients, these changes will be lost. Would you like to continue?
              </CModalBody>

              <CModalFooter
                style={{
                  backgroundColor: '#191919',
                  borderTop: '1px solid gray',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '10px',
                  padding: '10px',
                  borderRadius: '0 0 10px 10px',
                }}
              >
                <CButton color="secondary" onClick={() => setShowOverwriteModal(false)} style={{ border: 'none', color: 'white', borderRadius: '6px', padding: '8px 20px' }}>
                  Cancel
                </CButton>

                <CButton
                  color="primary"
                  style={{ border: 'none', color: 'white', borderRadius: '6px', padding: '8px 20px' }}
                  onClick={() => {
                    setShowOverwriteModal(false)
                    GetPatientTreatmentsNotes()
                  }}
                >
                  Download
                </CButton>
              </CModalFooter>
            </CModal>

            {/* <Pageloader isLoading={(!groupedUpdatedFilteredPatients || Object.keys(groupedUpdatedFilteredPatients).length === 0) && filteredPatientData.length === 0} /> */}
            {/* <Pageloader isLoading={isRefreshLoad} /> */}
          </div>
        )}
      </div>
    </>
  )
}
export default PatientProviderAppointment
